import React from 'react';
import BillDetailCard from '../../modules/crm/inPatient/newAdmission/panels/cards/BillDetailCard/BillDetailCard';
import CustomerDetail from '../../modules/crm/inPatient/newAdmission/panels/cards/CustomerDetail/CustomerDetail';
import FrontDeskActions from '../../modules/crm/frontDesk/frontDeskActions';
import { getDateWithTextMonth, isDateLessThenToday, getDateWithTime } from '../../utils/dateTimeUtils';
import TreatmentDetail from '../../modules/crm/inPatient/newAdmission/panels/cards/TreatmentDetail/TreatmentDetail';
import { getDefaultStr, isAvailable, isBlocked } from '../../modules/crm/inPatient/service/crmUtils';
import UpdateDetail from '../components/fileUpload/HospitalizationCard';
import SettlementDetail from '../components/fileUpload/UploadSettlementDocs';
import BuddhiMedFileUpload from '../components/fileUpload/buddhimedFileUpload/BuddhiMedFileUpload';
import NewAdmission from '../../modules/crm/inPatient/newAdmission/NewAdmission';
import Detail from '../../modules/crm/inPatient/detail/ClaimDetail';
import List from '../../modules/crm/inPatient/list/InPatientList';
import {
  getNextForNewAdmission,
  getTitle,
  hisGetTitle,
  hospitalizationModalValidation,
  lastTabFileUploadValidation,
  lastTabSubmitIr,
  lastTabSubmitSettlement,
} from '../../utils/fileUploadUtils';
import { Button, Popover, Tooltip } from 'antd';
import { ReactComponent as Information } from '../../assets/images/svg/i_information.svg';
import NumberFormatView from '../components/NumberFormatView/NumberFormatView';
import { DeleteOutlined, EyeInvisibleOutlined, EyeOutlined, MoreOutlined } from '@ant-design/icons';
import InPatientListActions from '../components/InPatientListActions/InPatientListActions';
import CustomFilterDropdownIcon from '../components/filterDropdownComponent/CustomFilterDropdownIcon';
import {
  authFeatureConstants, NOTREQUIRED } from './commonConstants';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import FilterDropdownComponent from '../components/filterDropdownComponent/FilterDropdownComponent';
import { canActivate, getTruncatedString } from '../../utils/utility';
import features from '../../config/featureList.json';
import { DownloadCertificate, GetAdhaarNumber, GetCard, GetHealthIdForm, GetOTP, GetPhoneNumber } from '../../modules/crm/inPatient/IdCard/IdCard';
import { confirmAdhaarOTP, confirmOTP, confirmOTPAndFetchInfo, fetchCowinCert,
   saveAdhaarNumber, saveNumber, savePhrAddress } from '../../store/actions/idCardAction';
import AutomatedTreatmentDetail from '../../modules/crm/inPatient/newAdmission/panels/cards/AutomatedTreatmentDetail/AutomatedTreatmentDetail';
import QueryResponse from '../components/fileUpload/QueryResponse';
import ClaimListActions from '../components/Grievance/ClaimListActions';
import {Payer} from '../models/payer.model';
import CourierStatusTimeLine from '../../modules/crm/inPatient/newAdmission/panels/cards/ClaimDetailHeader/CourierStatusTimeLine';
import CustomSort from '../components/customSort/CustomSort';
import InpatientRenderActions from '../components/InPatientListActions/InPatientColumnRenderActions';
import NonHISBuddhimedFileUpload from '../components/fileUpload/buddhimedFileUpload/NonHISBuddhimedFileUpload';
import BeneficiarySearch from '../../modules/crm/inPatient/newAdmission/panels/BeneficiarySearch/BeneficiarySearch';
import ApplicationDetail from '../services/applicationDetail.service';
import NewAdmissionRedesign from '../../modules/crm/inPatient/newAdmission/NewAdmissionRedesign';
import HISBuddhimedFileUpload from '../components/fileUpload/buddhimedFileUpload/HISBuddhimedFileUpload';
import MaskedNameWithToggle from '../components/crmFormElement/MaskedInputWithToggle';
import { GLOBAL_URL } from './dataServiceUrl';
import { FilterDropDownRemarks } from '../components/filterDropdownComponent/FilterDropDownComponentRemarks';
import ElapsedTimeComponent from '../components/filterDropdownComponent/ElapsedTimeComponent';

export const PACKAGES = ['package', 'roomRent', 'pharmacy', 'medicalEquipment', 'consultation', 'consumables', 'investigations'];
export const PAST_MEDICAL_HISTORY = [
  { value: 'hypertension', name: 'hypertension' },
  { value: 'highColestrol', name: 'hypertension' },
];
export const RADIO_SWITCH_OPTION = ['Yes', 'No'];

export const BENEFICIARY_SEARCH_OPTION = ['Member ID', 'Employee ID', 'Policy No.'];
export const BENEFICIARY_SEARCH_OPTION_COI = ['Member ID', 'Policy No.', 'COI No.'];
export const BENEFICIARY_SEARCH_OPTION_ABHI = ['Member ID', 'Policy No.']; // beneficiary search for abhi
export const BENEFICIARY_SEARCH_WITHOUT_POLICY = ['Member ID', 'Employee ID'];
export const BENEFICIARY_SEARCH_WITH_ONLY_MEMBERID = ['Member ID'];
export const BENEFICIARY_SEARCH_WITH_ONLY_CLIENTID = ['Client ID'];
export const BENEFICIARY_SEARCH_WITH_POLICYNAME = ['Member ID', 'Employee ID', 'Policy No.', 'Policy Name'];
export const BENEFICIARY_SEARCH_WITH_CORPORATENAME = ['Member ID', 'Policy No.', 'Corporate Name'];
export const BENEFICIARY_SEARCH_WITH_CERTIFICATE_NO = ['Member ID', 'Policy No.', 'Certificate No.'];
export const BENEFICIARY_SEARCH_OPTION_SHAI = ['Customer ID (Group / Retail)', 'Employee ID', 'Policy No. (Retail Only)'];
export const GOVT_SCHEME_SEARCH_OPTION: any = {
  MPKAY: ['Sewarth No.'],
  CMHT: ['URN No.'],
  ABY: ['KGID'],
  Yeshasvini: ['URN No.'],
  'ABY-Fire': ['KGID'],
  'ABY-Prison': ['KGID'],
  KSRTC: ['URN No.'],
  Yeshasvini_2025: ['URN No.'],
};
export const BENEFICIARY_SEARCH_OPTION_MDI = ['MDID', 'MIN No. / Employee ID', 'Policy No.'];
export const NEW_ADMISSION_FORM_KEY = ['customerDetail', 'treatmentDetail', 'billDetail'];
export const BENEF_POLICY_NO_RPA_PAYERS = ['VIDAL', 'Bajaj', 'TATA AIG'];
export const [customerDetail, treatmentDetail, billDetail] = NEW_ADMISSION_FORM_KEY;
export const DETAIL_NAV = (): any[] => {
  const isPreAuthNewDesignEnabled = ApplicationDetail?.instance?.getIsPreAuthNewDesignEnabled();
  return [
    {
      tabName: 'Member Details',
      isTouched: false,
      isValidated: false,
      formComponent: CustomerDetail,
      formKey: customerDetail,
      beforeFormComponent: isPreAuthNewDesignEnabled ? null : BeneficiarySearch,
      additionalFunction: true,
    },
    {
      tabName: 'Treatment Details',
      isTouched: false,
      isValidated: false,
      formComponent: TreatmentDetail,
      formKey: treatmentDetail,
    },
    {
      tabName: 'Bill Details',
      isTouched: false,
      isValidated: false,
      formComponent: BillDetailCard,
      formKey: billDetail,
    },
  ];
};

export const NEW_DETAIL_NAV = (): any[] => {
  const isPreAuthNewDesignEnabled = ApplicationDetail?.instance?.getIsPreAuthNewDesignEnabled();
  return [
    {
      tabName: 'Member Details',
      isTouched: false,
      isValidated: false,
      formComponent: CustomerDetail,
      formKey: customerDetail,
      beforeFormComponent: isPreAuthNewDesignEnabled ? null : BeneficiarySearch,
      additionalFunction: true,
    },
    {
      tabName: 'Treatment Details',
      isTouched: false,
      isValidated: false,
      formComponent: AutomatedTreatmentDetail,
      formKey: treatmentDetail,
    },
    {
      tabName: 'Bill Details',
      isTouched: false,
      isValidated: false,
      formComponent: BillDetailCard,
      formKey: billDetail,
    },
  ];
};

export const NEW_DETAIL_NAV_NO_BENEF: any[] = [
  {
    tabName: 'Member Details',
    isTouched: false,
    isValidated: false,
    formComponent: CustomerDetail,
    formKey: customerDetail,
    additionalFunction: true,
  },
  {
    tabName: 'Treatment Details',
    isTouched: false,
    isValidated: false,
    formComponent: AutomatedTreatmentDetail,
    formKey: treatmentDetail,
  },
  {
    tabName: 'Bill Details',
    isTouched: false,
    isValidated: false,
    formComponent: BillDetailCard,
    formKey: billDetail,
  },
];

export const BUDDHIMED_NAV_EDIT = [
  {
    title: 'Update Details',
    component: UpdateDetail,
    customValidation: hospitalizationModalValidation,
    nextButtonName: 'Next',
  },
  {
    title: getTitle,
    component: BuddhiMedFileUpload,
    customValidation: lastTabFileUploadValidation,
    nextButtonName: 'Next',
    isShowDraft: true,
  },
];

export const BUDDHIMED_NAV_EDIT_HIS = [
  {
    title: 'Update Details',
    component: UpdateDetail,
    customValidation: hospitalizationModalValidation,
    nextButtonName: 'Next',
  },
  {
    title: getTitle,
    component: HISBuddhimedFileUpload,
    customValidation: lastTabFileUploadValidation,
    nextButtonName: 'Next',
    isShowDraft: true,
  },
];

export const BUDDHIMED_NAV_EDIT_NON_HIS = [
  {
    title: 'Update Details',
    component: UpdateDetail,
    customValidation: hospitalizationModalValidation,
    nextButtonName: 'Next',
  },
  {
    title: getTitle,
    component: NonHISBuddhimedFileUpload,
    customValidation: lastTabFileUploadValidation,
    nextButtonName: 'Next',
    isShowDraft: true,
  },
];

export const BUDDHIMED_NAV_FREE_EDIT = [
  {
    title: 'Update Details',
    component: UpdateDetail,
    customValidation: hospitalizationModalValidation,
    nextButtonName: 'Next',
  },
  {
    title: getTitle,
    component: BuddhiMedFileUpload,
    customValidation: lastTabFileUploadValidation,
    nextButtonName: 'Next',
    skipButton: true,
    isShowDraft: true,
  },
];

export const BUDDHIMED_NAV_FREE_EDIT_HIS = [
  {
    title: 'Update Details',
    component: UpdateDetail,
    customValidation: hospitalizationModalValidation,
    nextButtonName: 'Next',
  },
  {
    title: getTitle,
    component: HISBuddhimedFileUpload,
    customValidation: lastTabFileUploadValidation,
    nextButtonName: 'Next',
    skipButton: true,
    isShowDraft: true,
  },
];

export const BUDDHIMED_NAV_FREE_EDIT_NON_HIS = [
  {
    title: 'Update Details',
    component: UpdateDetail,
    customValidation: hospitalizationModalValidation,
    nextButtonName: 'Next',
  },
  {
    title: getTitle,
    component: NonHISBuddhimedFileUpload,
    customValidation: lastTabFileUploadValidation,
    nextButtonName: 'Next',
    skipButton: true,
    isShowDraft: true,
  },
];

export const BUDDHIMED_NAV_IR = [
  {
    title: getTitle,
    component: QueryResponse,
    nextButtonName: 'Submit',
    customValidation: lastTabSubmitIr,
    isShowDraft: true,
  },
];

export const BUDDHIMED_NAV_NEW_ADMISSION = [
  {
    title: getTitle,
    component: BuddhiMedFileUpload,
    customValidation: lastTabFileUploadValidation,
    dynamicNextButton: getNextForNewAdmission,
    allowFormSubmit: true,
  },
];

export const BUDDHIMED_NAV_NEW_ADMISSION_HIS = [
  {
    title: hisGetTitle,
    component: HISBuddhimedFileUpload,
    customValidation: lastTabFileUploadValidation,
    dynamicNextButton: getNextForNewAdmission,
    allowFormSubmit: true,
  },
];

export const BUDDHIMED_NAV_NEW_ADMISSION_NON_HIS = [
  {
    title: hisGetTitle,
    component: NonHISBuddhimedFileUpload,
    customValidation: lastTabFileUploadValidation,
    dynamicNextButton: getNextForNewAdmission,
    allowFormSubmit: true,
  },
];
export const BUDDHIMED_NAV_SETTLEMENT = [
  {
    title: 'Initiating Settlement',
    component: SettlementDetail,
    nextButtonName: 'Submit',
    customValidation: lastTabSubmitSettlement,
    isShowDraft: true,
  },
];

export const CREATE_HEALTH_ID_CARD = [
  {
    title: 'Create ABHA (Health ID)',
    component: GetAdhaarNumber,
    submitHandler: saveAdhaarNumber,
    submitUrl: '/Health/Mobile/Aadhar/GenerateOTP',
    nextButtonName: 'Send OTP',
  },
  {
    title: 'Create ABHA (Health ID)',
    component: GetOTP,
    submitHandler: confirmAdhaarOTP,
    submitUrl: '/Health/Mobile/Aadhar/VerifyOTP',
    otpTimeout: 601000,
    nextButtonName: 'Submit OTP',
  },
  {
    title: 'Create ABHA (Health ID)',
    component: GetPhoneNumber,
    submitHandler: saveNumber,
    submitUrl: '/Health/Mobile/Aadhar/checkAndGenerateMobileOTP',
    nextButtonName: 'Send OTP',
  },
  {
    title: 'Create ABHA (Health ID)',
    component: GetOTP,
    submitHandler: confirmOTP,
    submitUrl: '/Health/Mobile/Aadhar/verifyMobileOTP',
    otpTimeout: 601000,
    nextButtonName: 'Submit OTP',
  },
  {
    title: 'Create ABHA (Health ID)',
    component: GetHealthIdForm,
    submitHandler: savePhrAddress,
    submitUrl: 'Health/Mobile/Aadhar/CreateHealthIdWithPreVerified',
    nextButtonName: 'Create Health ID',
  },
  {
    title: 'Your ABHA has been successfully created!',
    component: GetCard,
  },
];

export const CREATE_COWIN_CERT_CARD = [
  {
    title: 'Download CoWIN vaccine certificate',
    component: GetPhoneNumber,
    submitHandler: saveNumber,
    submitUrl: '/Covin/GenerateOTP',
    nextButtonName: 'Send OTP',
  },
  {
    title: 'Download CoWIN vaccine certificate',
    component: GetOTP,
    submitHandler: fetchCowinCert,
    submitUrl: '/Covin/VerifyOTP',
    otpTimeout: 180576,
    nextButtonName: 'Submit OTP',
  },
  {
    title: 'Covid vaccination (CoWin) certificate is ready!',
    component: DownloadCertificate,
  },
];

export const CHECK_HEALTH_ID_INFO = [
  {
    title: 'Profile Verification',
    component: GetAdhaarNumber,
    submitHandler: saveAdhaarNumber,
    submitUrl: '/Health/Mobile/Aadhar/GenerateOTP',
    nextButtonName: 'Send OTP',
  },
  {
    title: 'Profile Verification',
    component: GetOTP,
    submitHandler: confirmOTPAndFetchInfo,
    submitUrl: '/Health/Mobile/Aadhar/VerifyOTP',
    otpTimeout: 601000,
    nextButtonName: 'Submit OTP',
    isSuccessStep: false,
  },
];

export const ID_CARD_TYPE = {
  HEALTH: 'HEALTH',
  COWIN: 'COWIN',
  CHECK_HEALTH_ID: 'CHECK_HEALTH_ID',
};

export const ID_CARD_NAV = {
  HEALTH: CREATE_HEALTH_ID_CARD,
  COWIN: CREATE_COWIN_CERT_CARD,
  CHECK_HEALTH_ID: CHECK_HEALTH_ID_INFO,
};

export const DEFAULT_ADMISSION_FORM_VALUE = {
  [customerDetail]: {},
  [treatmentDetail]: {},
  [billDetail]: {},
};

// export const REIMBURSEMENT_FORM_VALUE = {
//   [customerDetail]: {},
//   [treatmentDetail]: {},
// }
export const INPATIENT_ACTIONS = ['All', 'Admission', 'Discharge', 'Query', 'Settlement', 'Settled', 'Denied'];

const getInPatientActions = (text: any, record: any, index: any, enablers: any): any => {
  return (<InPatientListActions text={text} record={record} index={index} enablers={enablers} />);
};
export const getGrievanceActions = (): any => {
  return (<ClaimListActions />);
};
export const renderIPOptions = (text: any, record: any, index: any): any => {
  const { allowStatus, dod, payerId, payerProductCode } = record;
  const uniqueIdentifier = `${payerId}${payerProductCode || ''}`;
  const {configuredPayers: allPayers} = localStorage.getItem('providerDetail') ?
    JSON.parse(localStorage.getItem('providerDetail') || '{"configuredPayers":[]}') : {configuredPayers: []};
  let isCancelable;
  let isConfirmable;
  let isEnhance;
  let isDischarge;
  let isCashlessSubmission;
  let isQuery;
  let isFreeEdit;
  let isClaimSubmissionDisabled;
  let isEasyDischargeQuery;
  let isEasyDischarge;
  let isReconsider;
  let isDischargeContestCTA;
  const isAuthorized = canActivate(features.EDIT_ADMISSION);
  if (allowStatus?.length) {
    const { CANCEL, CONFIRMATION, CASHLESSSUMBIT, SUBMITINFO,
      ENHANCEMENT, EDIT, ENHANCEMENTQUERYREPLIED, DISCHARGEQUERYREPLIED,
      CLAIMQUERYREPLIED, EASYDISCHARGEINITIATED, EASYDISCHARGEQUERYREPLIED, DISCHARGE, RECONSIDER, DISCHARGECONTEST } = actions;
    isCancelable = allowStatus.some(({ actionName }: any): boolean => actionName === CANCEL);
    isConfirmable = allowStatus.some(({ actionName }: any): boolean => actionName === CONFIRMATION);
    isEnhance = isAvailable(allowStatus, ENHANCEMENT) &&
      !isBlocked(allPayers?.filter((payer: Payer): boolean =>
        payer?.uniqueIdentifier === uniqueIdentifier)?.[0]?.blockedActions, ENHANCEMENT);
    isDischarge = isAvailable(allowStatus, DISCHARGE) &&
    !isBlocked(allPayers?.filter((payer: Payer): boolean =>
        payer?.uniqueIdentifier === uniqueIdentifier)?.[0]?.blockedActions, DISCHARGE);
    isDischargeContestCTA = isAvailable(allowStatus, DISCHARGECONTEST) &&
    !isBlocked(allPayers?.filter((payer: Payer): boolean =>
        payer?.uniqueIdentifier === uniqueIdentifier)?.[0]?.blockedActions, DISCHARGECONTEST);
    isCashlessSubmission = isDateLessThenToday(dod, record?.payerName) ? isAvailable(allowStatus, CASHLESSSUMBIT) &&
      !isBlocked(allPayers?.filter((payer: Payer): boolean =>
        payer?.uniqueIdentifier === uniqueIdentifier)?.[0]?.blockedActions, CASHLESSSUMBIT)
      : false;

    isQuery = (isAvailable(allowStatus, SUBMITINFO) || isAvailable(allowStatus, ENHANCEMENTQUERYREPLIED)
      || isAvailable(allowStatus, DISCHARGEQUERYREPLIED) || isAvailable(allowStatus, CLAIMQUERYREPLIED))
      && !isBlocked(allPayers?.filter((payer: Payer): boolean =>
        payer?.uniqueIdentifier === uniqueIdentifier)?.[0]?.blockedActions, SUBMITINFO);
    isFreeEdit = isAvailable(allowStatus, EDIT);
    isEasyDischargeQuery = isAvailable(allowStatus, EASYDISCHARGEQUERYREPLIED);
    isEasyDischarge = isAvailable(allowStatus, EASYDISCHARGEINITIATED);
    isClaimSubmissionDisabled = allPayers?.filter((payer: Payer): boolean => payer?.id === record?.payerId)?.[0]?.isClaimSubmissionDisabled;
    isReconsider = isAvailable(allowStatus, RECONSIDER);
  }
  const enablers = { isCancelable, isConfirmable, isEnhance, isCashlessSubmission, isQuery, isFreeEdit, isClaimSubmissionDisabled ,
     isEasyDischarge, isEasyDischargeQuery, isDischarge, isReconsider, isDischargeContestCTA};
  return (
    (isAuthorized && (isCancelable || isQuery || isCashlessSubmission || isEnhance || isConfirmable || isFreeEdit || isDischarge
      || isClaimSubmissionDisabled || isEasyDischarge || isEasyDischargeQuery || isReconsider || isDischargeContestCTA)) &&
    <> <Popover placement="left" content={getInPatientActions(text, record, index, enablers)}>
      <Button type="text" className="mr-0 ml-0" data-testid="actions" icon={<MoreOutlined className="fsize_lg" />} />
    </Popover>{getGrievanceActions && <p>{getGrievanceActions}</p>}</>
  );
};
export const renderDraftIPOptions = (text: any, record: any, index: any): any => {
  const { islocked = false } = record;

  if (islocked || !canActivate(authFeatureConstants.NEW_ADMISSION)) {
    return (<></>);
  }

  const handleButtonClick = (e: any): any => {
    e?.stopPropagation(); // to prevent opening of a claim on click of delete icon
  };

  return (
    <Popover placement="left" content={getInPatientActions(text, record, index, {islocked, isDraft: true})}>
      <Button type="text" className="mr-0 ml-0" data-testid="actions" onClick={handleButtonClick}
       icon={<DeleteOutlined className="fsize_lg" />} />
    </Popover>
  );
};

export const IP_DROPDOWN_SEARCH_INPUT_TYPES = {
  TEXT: 'TEXT',
  AMOUNT: 'AMOUNT',
  DATE_RANGE: 'DATE_RANGE',
  MULTISELECT_CHECKBOX: 'MULTISELECT_CHECKBOX',
  MULTISELECT_DROPDOWN: 'MULTISELECT_DROPDOWN',
};

export const getColumnSearchDropdown = (extraParams: any): any => ({
  filterDropdown: (props: FilterDropdownProps): any => {
    return (<FilterDropdownComponent {...props} {...extraParams} />);
  },
});

export const getInPatientTableMapping = (isNewAdmissionBOH: boolean): any => {

  const inPatientTableMappingColumns = {
    PAYER_NAME: {
      title: (<div className="columnsTitle"><div><div>Payer</div>
           </div>
      <span className="sort-icon-container">
      <CustomSort sortKey="payerName"/>
    </span>
    </div>),
      customTitle: 'Payer',
      dataIndex: 'payerName',
      key: 'payerName',
      className: 'text-elipsis',
      render: (payerName: any, row: any): any => (
        getTruncatedString(getDefaultStr(payerName, true))
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="payerId" />,
      ...getColumnSearchDropdown({
        filterKey: 'payerId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.MULTISELECT_DROPDOWN,
        placeholder: 'Search payer',
        additionalPath: '[\'mailBox\'][\'payerConfiguration\']',
        optionPath: '[\'payerList\'][\'allPayers\']',
      }),
    },
    INSURER_NAME: {
      title: <div className="columnsTitle"><div>Insurer Name</div> <span className="sort-icon-container">
      <CustomSort sortKey="insurerName"/>
    </span></div>,
     customTitle: 'Insurer Name',
      dataIndex: 'insurerName',
      key: 'insurerName',
      className: 'text-elipsis',
      render: (insurerName: any, row: any): any => (
        <Tooltip placement="right" title={row.insurerName}>
          <div className="text-elipsis insurer-name-column">
            {row.insurerName}
          </div>
        </Tooltip>
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="insurerName" />,
      ...getColumnSearchDropdown({
        filterKey: 'insurerName',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.MULTISELECT_DROPDOWN,
        placeholder: 'Select Insurer Names',
        optionPath: '[\'lookUp\'][\'allInsurers\']',
      }),
    },
    IP_NO: {
      title: <Popover placement="bottom"
      content={
        <span
       className="inpatient_tooltip_header"
        >
          InPatient Number
        </span>
      }>IP No.</Popover>,
      dataIndex: 'inPatientNo',
      key: 'inPatientNo',
      customTitle: 'IP No.',
      render: (inPatientNo: any): any => (
        getDefaultStr(inPatientNo, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="inPatientNo" />,
      ...getColumnSearchDropdown({
        filterKey: 'inPatientNo',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search IP No.',
      }),
    },
    utrNo: {
      title: 'UTR No.',
      dataIndex: 'transactionId',
      key: 'transactionId',
      render: (transactionId: any): any => (
        getDefaultStr(transactionId, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="transactionId" />,
      ...getColumnSearchDropdown({
        filterKey: 'transactionId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search UTR No.',
      }),
    },
    MAID: {
      title: 'Member Id',
      dataIndex: 'memberId',
      key: 'memberId',
      render: (memberId: any): any => (
        getDefaultStr(memberId, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="memberId" />,
      ...getColumnSearchDropdown({
        filterKey: 'memberId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Member Id',
      }),
    },
    policy_number: {
      title: 'Policy Number',
      dataIndex: 'policyNo',
      key: 'policyNo',
      render: (policyNo: any): any => (
        getDefaultStr(policyNo, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="policyNo" />,
      ...getColumnSearchDropdown({
        filterKey: 'policyNo',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Policy Number',
      }),
    },
    CLAIM_NO: {
      title: 'Claim No.',
      dataIndex: 'payerClaimNo',
      key: 'payerClaimNo',
      render: (claimNo: any): any => (
        getDefaultStr(claimNo, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="payerClaimNo" />,
      ...getColumnSearchDropdown({
        filterKey: 'payerClaimNo',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Claim No.',
      }),
    },
    MEMBER_NAME: {
      title: (<div className="columnsTitle"><div>Patient Name</div>
        <span className="sort-icon-container">
          <CustomSort sortKey="patientName" />
        </span></div>),
      customTitle: 'Patient Name',
      className: 'text-left',
      dataIndex: 'patientName',
      key: 'patientName',
      render: (patientName: any): any => ({
        children: getDefaultStr(patientName, true),
      }
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="patientName" />,
      ...getColumnSearchDropdown({
        filterKey: 'patientName',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Member Name',
      }),
    },
    CLAIMED_AMOUNT: {
      title: <div className="columnsTitle text-left"><div>Claimed Amount</div>
      <span className="sort-icon-container">
        <CustomSort sortKey="claimedAmount"/>
        </span></div>,
     customTitle: 'Claimed Amount',
      key: 'claimedAmount',
      dataIndex: 'claimedAmount',
      className: 'column-money text-right',
      render: (amount: any): any => (
        <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="claimedAmount" />,
      ...getColumnSearchDropdown({
        filterKey: 'claimedAmount',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.AMOUNT,
        placeholder: 'Search Claimed Amount',
      }),
    },
    APPROVED_AMOUNT: {
      title: <div className="columnsTitle text-left"><div>Approved Amount</div>
      <span className="sort-icon-container">
        <CustomSort sortKey="approvedAmount"/>
        </span></div>,
      customTitle: 'Approved Amount',
      key: 'approvedAmount',
      dataIndex: 'approvedAmount',
      className: 'column-money text-right',
      render: (amount: any): any => (
        <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="approvedAmount" />,
      ...getColumnSearchDropdown({
        filterKey: 'approvedAmount',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.AMOUNT,
        placeholder: 'Search Approved Amount',
      }),
    },
    STATUS: {
      title: <div>Status</div>,
      dataIndex: 'statusName',
      key: 'statusName',
      customTitle: 'Status',

      render: (status: any, data: any): any => {
        let statusClassName = '';

        CRM_INPATIENT_STATUS_COLOUR.map((colorObject: any): any => {
          if (colorObject.StatusId === data?.statusId) {
            statusClassName = colorObject.class;
          }
        });
        return (
          <span className={`fsize_sm bold status-text ${statusClassName}`}>{status && status}</span>
        );
      },
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="statusId" />,
      ...getColumnSearchDropdown({
        filterKey: 'statusId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.MULTISELECT_DROPDOWN,
        placeholder: 'Select Status',
        optionPath: '[\'lookUp\'][\'payerClaimStatuses\']',
      }),
    },
    // LAST_UPDATE: {
    //   title: 'Last Update',
    //   dataIndex: 'lastUpdate',
    //   key: 'lastUpdate',
    //   sorter: true,
    //   sortOrder: false,
    //   render: (date: any): any => (
    //     date && getDateWithTextMonth(date)
    //   ),
    // },
    DOA: {
      title: (<div className="columnsTitle"><div><Popover placement="bottom"
        content={
        <span
       className="inpatient_tooltip_header"
        >
          Date of Admission
        </span>
      } className="force-single-line">
        DOA <Information className="info-icon" />
      </Popover></div><span className="sort-icon-container">
          <CustomSort sortKey="doa" />
        </span></div>),
      customTitle: 'DOA',
      dataIndex: 'doa',
      key: 'doa',
      render: (date: any): any => (
        date && getDateWithTextMonth(date)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="doa" />,
      ...getColumnSearchDropdown({ filterKey: 'doa', inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE }),
    },
    DOD: {
      title: (<div className="columnsTitle"><div><Popover content={
        <span
       className="inpatient_tooltip_header"
        >
        Date of Discharge</span>
      } className="force-single-line"  placement="bottom">
        DOD <Information className="info-icon" />
      </Popover></div><span className="sort-icon-container">
          <CustomSort sortKey="dod" />
        </span></div>
      ),
      customTitle: 'DOD',
      dataIndex: 'dod',
      key: 'dod',
      render: (date: any): any => (
        date && getDateWithTextMonth(date)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="dod" />,
      ...getColumnSearchDropdown({ filterKey: 'dod', inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE }),
    },
    COURIER_STATUS: {
      title: 'Courier Status',
      dataIndex: 'courierStatus',
      key: 'courierStatus',
      render: (courierStatus: any, record: any): any => (
        <CourierStatusTimeLine
          courierStatus={courierStatus}
          courierTrackingHistory={record?.courierTrackingHistory}
        />
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="courierStatus" />,
      ...getColumnSearchDropdown({
        filterKey: 'courierStatus',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Courier Status',
      }),
    },
    LAST_MODIFIED_DATE: {
      title: (<div className="columnsTitle">
        <div>
          Last Modified Date
        </div>
        <span className="sort-icon-container">
          <CustomSort sortKey="modifiedOn" />
        </span>
      </div>),
      customTitle: 'Last Modified Date',
      dataIndex: 'modifiedOn',
      key: 'modifiedOn',
      render: (date: any): any => (
        date && getDateWithTextMonth(date)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="modifiedOn" />,
      ...getColumnSearchDropdown({ filterKey: 'modifiedOn', inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE }),
    },
    CLAIM_CREATION_DATE: {
      title: (<div className="columnsTitle">
        <div>
          Claim Creation Date
        </div>
        <span className="sort-icon-container">
          <CustomSort sortKey="createdOn" />
        </span>
      </div>),
      customTitle: 'Claim Creation Date',
      dataIndex: 'createdOn',
      key: 'createdOn',
      render: (date: any): any => (
        date && getDateWithTextMonth(date)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="createdOn" />,
      ...getColumnSearchDropdown({ filterKey: 'createdOn', inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE }),
    },
    DOCTOR_NAME: {
      title: (
        <div className="columnsTitle">
          <div>
            <Tooltip title="Doctor Name" placement="bottom">
              Doctor Name
            </Tooltip>
          </div>
          <span className="sort-icon-container">
            <CustomSort sortKey="doctorName" />
          </span>
        </div>
      ),
      customTitle: 'Doctor Name',
      className: 'text-left',
      dataIndex: 'doctorName',
      key: 'doctorName',
      render: (doctorName: any): any => ({
        children: getDefaultStr(doctorName, true),
      }),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="doctorName" />,
      ...getColumnSearchDropdown({
        filterKey: 'doctorName',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Doctor Name',
      }),
    },
    Elapsed_Time: {
      title: (<div className="columnsTitle"><div>
      <FilterDropDownRemarks />
     <Popover placement="bottom" content={
        <span
       className="inpatient_tooltip_header">
          Elapsed Time
        </span>
      } className="force-single-line">
        Elapsed Time <Information className="info-icon" />
      </Popover></div><span className="sort-icon-container ml-80precent">
          <CustomSort sortKey="elapsedTime" />
        </span></div>),
      customTitle: 'Elapsed Time',
      dataIndex: 'ElapsedTime',
      key: 'ElapsedTime',
      width: '170px',
      render: (text: string, record: any): JSX.Element =>
        <ElapsedTimeComponent targetMs={record?.elapsedTime}
    />,
    },
    ACTIONS: {
      title: (<div className="force-single-line">
        Actions
      </div>
      ),
      customTitle: 'Actions',
      dataIndex: 'action',
      key: 'action',
      render: (text: string, record: any): any => {
        const selectedData = {
          hospActionId: record.hospActionId,
          payerClaimNo: record.payerClaimNo,
          payerId: record.payerId,
          providerId: record.providerId,
          allowStatus: record.allowStatus,
          isFollowUpEligible: record.isFollowUpEligible,
      };
        return(
        <InpatientRenderActions data={selectedData} />
      ); },
    },
    UHID: {
      title: (<div className="columnsTitle"><div><Tooltip title="UHID" placement="bottom">UHID</Tooltip></div>
        <span className="sort-icon-container">
          <CustomSort sortKey="uhid" />
        </span></div>),
      customTitle: 'UHID',
      className: 'text-left',
      dataIndex: 'uhid',
      key: 'uhid',
      render: (uhid: any): any => ({
        children: getDefaultStr(uhid, true),
      }
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="uhid" />,
      ...getColumnSearchDropdown({
        filterKey: 'uhid',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search UHID',
      }),
    },
  };

  return isNewAdmissionBOH ? {
    CENTER: {
      title: (<div className="columnsTitle"><div>Center</div><span className="sort-icon-container">
        <CustomSort sortKey="providerName" />
      </span></div>),
      customTitle: 'Center',
      dataIndex: 'providerName',
      key: 'providerName',
      className: 'text-elipsis',
      render: (providerName: any, row: any): any => (
        getTruncatedString(getDefaultStr(providerName, true))
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="providerId" />,
      ...getColumnSearchDropdown({
        filterKey: 'providerId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.MULTISELECT_DROPDOWN,
        placeholder: 'Search Center',
        optionPath: '[\'applicationDetail\'][\'_applicationDetail\'][\'groupProviders\']',
        labelKey: 'providerName',
        additionalLabelKey: 'providerRohiniCode',
        additionalLabelKeyDivider: '|',
      }),
    },
    ...inPatientTableMappingColumns,
  } : inPatientTableMappingColumns;
};

export const getDraftTableMapping = (isNewAdmissionBOH: boolean): any => {
  const draftTableMappingColumns = {
    PAYER_NAME: {
      title: (<div className="columnsTitle"><div><Tooltip title="TPA" placement="bottom">Payer</Tooltip>
           </div>
      <span className="sort-icon-container">
      <CustomSort sortKey="payerName"/>
      </span>
      </div>),
      customTitle: 'Payer',
      dataIndex: 'payerName',
      key: 'payerName',
      className: 'text-elipsis',
      render: (payerName: any, row: any): any => (
        getTruncatedString(getDefaultStr(payerName, true))
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="payerId" />,
      ...getColumnSearchDropdown({
        filterKey: 'payerId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.MULTISELECT_DROPDOWN,
        placeholder: 'Search payer',
        additionalPath: '[\'mailBox\'][\'payerConfiguration\']',
        optionPath: '[\'payerList\'][\'allPayers\']',
      }),
    },
    policy_number: {
      title: 'Policy Number',
      dataIndex: 'policyNo',
      key: 'policyNo',
      render: (policyNo: any): any => (
        getDefaultStr(policyNo, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="policyNo" />,
      ...getColumnSearchDropdown({
        filterKey: 'policyNo',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Policy Number',
      }),
    },
    IP_NO: {
      title: 'IP No.',
      dataIndex: 'inPatientNo',
      key: 'inPatientNo',
      render: (inPatientNo: any): any => (
        getDefaultStr(inPatientNo, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="inPatientNo" />,
      ...getColumnSearchDropdown({
        filterKey: 'inPatientNo',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search IP No.',
      }),
    },
    CLAIM_NO: {
      title: 'Claim No.',
      dataIndex: 'payerClaimNo',
      key: 'payerClaimNo',
      render: (claimNo: any): any => (
        getDefaultStr(claimNo, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="payerClaimNo" />,
      ...getColumnSearchDropdown({
        filterKey: 'payerClaimNo',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Claim No.',
      }),
    },
    MEMBER_NAME: {
     title: (<div className="columnsTitle"><div><Tooltip title="Patient Name" placement="bottom">Patient Name</Tooltip></div>
        <span className="sort-icon-container">
          <CustomSort sortKey="patientName" />
        </span></div>),
      customTitle: 'Patient Name',
      className: 'text-left',
      dataIndex: 'patientName',
      key: 'patientName',
      render: (patientName: any): any => ({
        children: getDefaultStr(patientName, true),
      }
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="patientName" />,
      ...getColumnSearchDropdown({
        filterKey: 'patientName',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Member Name',
      }),
    },
    STATUS: {
      title: <div>Status</div>,
      dataIndex: 'statusName',
      key: 'statusName',
      customTitle: 'Status',
      render: (status: any, data: any): any => {
        let statusClassName = '';

        CRM_INPATIENT_STATUS_COLOUR.map((colorObject: any): any => {
          if (colorObject.StatusId === data?.statusId) {
            statusClassName = colorObject.class;
          }
        });
        return (
          <span className={`fsize_sm bold status-text ${statusClassName}`}>{status && status}</span>
        );
      },
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="statusId" />,
      ...getColumnSearchDropdown({
        filterKey: 'statusId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.MULTISELECT_DROPDOWN,
        placeholder: 'Select Status',
        optionPath: '[\'lookUp\'][\'payerClaimStatuses\']',
      }),
    },
    DOA: {
     title: (<div className="columnsTitle"><div><Tooltip className="force-single-line" title="Date of Admission" placement="bottom">
        DOA <Information className="info-icon" />
      </Tooltip></div><span className="sort-icon-container">
          <CustomSort sortKey="doa" />
        </span></div>),
      customTitle: 'DOA',
      dataIndex: 'doa',
      key: 'doa',
      render: (date: any): any => (
        date && getDateWithTextMonth(date)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="doa" />,
      ...getColumnSearchDropdown({ filterKey: 'doa', inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE }),
    },
    DOD: {
       title: (<div className="columnsTitle"><div><Tooltip className="force-single-line" title="Date of Discharge" placement="bottom">
        DOD <Information className="info-icon" />
      </Tooltip></div><span className="sort-icon-container">
          <CustomSort sortKey="dod" />
        </span></div>
      ),
      customTitle: 'DOD',
      dataIndex: 'dod',
      key: 'dod',
      render: (date: any): any => (
        date && getDateWithTextMonth(date)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="dod" />,
      ...getColumnSearchDropdown({ filterKey: 'dod', inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE }),
    },
    DOCTOR_NAME: {
      title: (
        <div className="columnsTitle">
          <div>
            <Tooltip title="Doctor Name" placement="bottom">
              Doctor Name
            </Tooltip>
          </div>
          <span className="sort-icon-container">
            <CustomSort sortKey="doctorName" />
          </span>
        </div>
      ),
      customTitle: 'Doctor Name',
      className: 'text-left',
      dataIndex: 'doctorName',
      key: 'doctorName',
      render: (doctorName: any): any => ({
        children: getDefaultStr(doctorName, true),
      }),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="doctorName" />,
      ...getColumnSearchDropdown({
        filterKey: 'doctorName',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Doctor Name',
      }),
    },
    LAST_MODIFIED_DATE: {
      title: (<div className="columnsTitle">
        <div>
          Last Modified Date
        </div>
        <span className="sort-icon-container">
          <CustomSort sortKey="modifiedOn" />
        </span>
      </div>),
      customTitle: 'Last Modified Date',
      dataIndex: 'modifiedOn',
      key: 'modifiedOn',
      render: (date: any): any => (
        date && getDateWithTextMonth(date)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="modifiedOn" />,
      ...getColumnSearchDropdown({ filterKey: 'modifiedOn', inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE }),
    },
    CLAIM_CREATION_DATE: {
      title: (<div className="columnsTitle">
        <div>
          Claim Creation Date
        </div>
        <span className="sort-icon-container">
          <CustomSort sortKey="createdOn" />
        </span>
      </div>),
      customTitle: 'Claim Creation Date',
      dataIndex: 'createdOn',
      key: 'createdOn',
      render: (date: any): any => (
        date && getDateWithTextMonth(date)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="createdOn" />,
      ...getColumnSearchDropdown({ filterKey: 'createdOn', inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE }),
    },
    CLAIMED_AMOUNT: {
      title: <div className="columnsTitle text-left"><div>Claimed Amount</div>
      <span className="sort-icon-container">
        <CustomSort sortKey="claimedAmount"/>
        </span></div>,
     customTitle: 'Claimed Amount',
      key: 'claimedAmount',
      dataIndex: 'claimedAmount',
      className: 'column-money text-right',
      render: (amount: any): any => (
        <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="claimedAmount" />,
      ...getColumnSearchDropdown({
        filterKey: 'claimedAmount',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.AMOUNT,
        placeholder: 'Search Claimed Amount',
      }),
    },
    utrNo: {
      title: 'UTR No.',
      dataIndex: 'transactionId',
      key: 'transactionId',
      render: (transactionId: any): any => (
        getDefaultStr(transactionId, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="transactionId" />,
      ...getColumnSearchDropdown({
        filterKey: 'transactionId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search UTR No.',
      }),
    },
    APPROVED_AMOUNT: {
      title: <div className="columnsTitle text-left"><div>Approved Amount</div>
      <span className="sort-icon-container">
        <CustomSort sortKey="approvedAmount"/>
        </span></div>,
      customTitle: 'Approved Amount',
      key: 'approvedAmount',
      dataIndex: 'approvedAmount',
      className: 'column-money text-right',
      render: (amount: any): any => (
        <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="approvedAmount" />,
      ...getColumnSearchDropdown({
        filterKey: 'approvedAmount',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.AMOUNT,
        placeholder: 'Search Approved Amount',
      }),
    },
    COURIER_STATUS: {
      title: 'Courier Status',
      dataIndex: 'courierStatus',
      key: 'courierStatus',
      render: (courierStatus: any, record: any): any => (
        <CourierStatusTimeLine
          courierStatus={courierStatus}
          courierTrackingHistory={record?.courierTrackingHistory}
        />
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="courierStatus" />,
      ...getColumnSearchDropdown({
        filterKey: 'courierStatus',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Courier Status',
      }),
    },
    INSURER_NAME: {
      title: 'Insurer Name',
      dataIndex: 'insurerName',
      key: 'insurerName',
      render: (insurerName: any, row: any): any => (
        getTruncatedString( getDefaultStr(insurerName, true))
        ),
    },
    MAID: {
      title: 'Member Id',
      dataIndex: 'memberId',
      key: 'memberId',
      render: (memberId: any): any => (
        getDefaultStr(memberId, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="memberId" />,
      ...getColumnSearchDropdown({
        filterKey: 'memberId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Member Id',
      }),
    },
    Elapsed_Time: {
      title: (<div className="columnsTitle"><div>
      <FilterDropDownRemarks/>
     <Popover placement="bottom" content={
        <span
       className="inpatient_tooltip_header">
          Elapsed Time
        </span>
      } className="force-single-line">
        Elapsed Time <Information className="info-icon" />
      </Popover></div><span className="sort-icon-container ml-80precent">
          <CustomSort sortKey="elapsedTime" />
        </span></div>),
      customTitle: 'Elapsed Time',
      dataIndex: 'ElapsedTime',
      key: 'ElapsedTime',
      width: '170px',
      render: (text: string, record: any): JSX.Element =>
        <ElapsedTimeComponent targetMs={record?.elapsedTime}
    />,
    },
    ACTIONS: {
      title: (<div className="force-single-line">
        Actions
      </div>
      ),
      customTitle: 'Actions',
      dataIndex: 'action',
      key: 'action',
      render: (text: string, record: any): any => {
        const selectedData = {
          hospActionId: record.hospActionId,
          payerClaimNo: record.payerClaimNo,
          payerId: record.payerId,
          providerId: record.providerId,
          allowStatus: record.allowStatus,
          isFollowUpEligible: record.isFollowUpEligible,
      };
        return(
        <InpatientRenderActions data={selectedData} />
      ); },
    },
    UHID: {
      title: (<div className="columnsTitle"><div><Tooltip title="UHID" placement="bottom">UHID</Tooltip></div>
        <span className="sort-icon-container">
          <CustomSort sortKey="uhid" />
        </span></div>),
      customTitle: 'UHID',
      className: 'text-left',
      dataIndex: 'uhid',
      key: 'uhid',
      render: (uhid: any): any => ({
        children: getDefaultStr(uhid, true),
      }
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="uhid" />,
      ...getColumnSearchDropdown({
        filterKey: 'uhid',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search UHID',
      }),
    },
  };

  return isNewAdmissionBOH ? {
    CENTER: {
     title: (<div className="columnsTitle"><div>Center</div><span className="sort-icon-container">
        <CustomSort sortKey="providerName" />
      </span></div>),
     dataIndex: 'providerName',
      key: 'providerName',
      className: 'text-elipsis',
      render: (providerName: any, row: any): any => (
        getTruncatedString(getDefaultStr(providerName, true))
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="providerId" />,
      ...getColumnSearchDropdown({
        filterKey: 'providerId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.MULTISELECT_DROPDOWN,
        placeholder: 'Search Center',
        optionPath: '[\'applicationDetail\'][\'_applicationDetail\'][\'groupProviders\']',
        labelKey: 'providerName',
        additionalLabelKey: 'providerRohiniCode',
        additionalLabelKeyDivider: '|',
      }),
    },
    ...draftTableMappingColumns,
  } : draftTableMappingColumns;
};

export const IPATIENT_SEARCH_KEYS = [
  // { displayName: 'Member ID', key: 'memberId' },
  // { displayName: 'Claim No.', key: 'claimNo' },
  // { displayName: 'Member name', key: 'patientName' },
  // { displayName: 'In-patient No.', key: 'ipNumber' },
  { displayName: 'UTR No.', key: 'utrNo' },

];

export const IPATIENT_CLAIM_NO_SEARCH_KEYS = [
  { displayName: 'Claim No.', key: 'claimNo' },
];

export const OUTPATIENT_ACTIONS = [
  { displayName: 'Request Id', key: 'requestIds' },
  // { displayName: 'Employee ID', key: '' },
  { displayName: 'Email', key: 'emailId' },
  { displayName: 'Contact No.', key: 'contactNumber' },
  { displayName: 'Name', key: 'patientName' },
  // { displayName: 'Partner Order Id', key: '' },
  // { displayName: 'Member Id', key: '' },
];
export const lookUpMapWithState = {
  Past_History: 'pastHistory',
  Proposed_line_of_Treatment: 'proposedLineOfTreatment',
  Diagnosis_Type: 'diagnosisType',
  courier_service: 'courierService',
};

export const payerLookUpMapWithState = {
  Diagnosis: 'diagnosis',
  Procedure: 'procedure',
  document_type: 'documentType',
  room_type: 'roomType',
  insurer_name: 'insurerName',
  speciality: 'speciality',
  admission_type: 'admission_type',
};

export const lookUpNamesForReq = ['Past_History', 'Proposed_line_of_Treatment', 'Diagnosis_Type', 'bad_diagnosis', 'bad_treatment', 'courier_service'];
export const payerLookUpNamesForReq = ['Diagnosis', 'Procedure', 'document_type', 'room_type', 'insurer_name', 'unit', 'Grievance_Reason', 'corporate_name', 'speciality', 'admission_type', 'Proposed_line_of_Treatment', 'Past_History', 'Doctor_Qualification', 'State_Medical_Council', 'Package_charges', 'Room_rent_Nursing_charges', 'Investigation_charges', 'ICU_Charges', 'Consultation_charges', 'OT_charges', 'Surgeon_anesthetist', 'Medicine_consumables',
'Professional_Fees', 'High_Risk_Charges', 'Ambulance_Charges' , 'Blood_Charges', 'Cathlab_Charges', 'Diabetic_Charges', 'Medical_Equipment',
  'Food_Beverages', 'Implants_charges', 'Doctor_Specialization', 'Reason_For_Cancellation'];
export const payerLookUpNamesForReqCare = ['document_type', 'room_type', 'insurer_name', 'unit', 'Grievance_Reason', 'corporate_name', 'speciality', 'admission_type', 'Proposed_line_of_Treatment', 'Past_History',
  'Doctor_Qualification', 'State_Medical_Council', 'Package_charges', 'Room_rent_Nursing_charges', 'Investigation_charges', 'ICU_Charges', 'Consultation_charges', 'OT_charges', 'Surgeon_anesthetist',
  'Medicine_consumables', 'Professional_Fees', 'High_Risk_Charges', 'Ambulance_Charges', 'Blood_Charges', 'Cathlab_Charges', 'Diabetic_Charges', 'Medical_Equipment',
  'Food_Beverages', 'Implants_charges', 'Doctor_Specialization'];
export const payerLookUpNamesForRequest = ['Procedure', 'document_type', 'room_type', 'insurer_name', 'unit', 'Grievance_Reason', 'corporate_name', 'speciality', 'admission_type', 'Proposed_line_of_Treatment', 'Doctor_Specialization'];
export const payerLookUpNamesForGovt = ['District', 'Designations', 'relation'];
export const payerLookUpNamesForRPA = ['relation', 'Reason_For_Cancellation'];
export const payerLookUpNamesForOnMailPayer = [];
export const payerLookUpNamesForAllInsurer = ['insurer_name'];
export const payerLookUpNamesForAdministrationRoute = ['AdministrationRoute'];
export const payerLookUpNamesForGrievanceType = ['Grievance_Reason'];

export enum BILL_DETAIL_ENUM {
  package = 'Package',
  roomRent = 'Room rent & Nursing charges',
  totalRent = 'Total rent',
  nursingCharge = 'Nursing Charge',
  surgeonCharge = 'Surgeon Charge',
  physicianCharge = 'Physician Charge',
  consumables = 'Consumables',
  anesthetist = 'Anesthetist',
  investigations = 'Investigations',
  pharmacy = 'Pharmacy',
  consultation = 'Consultation',
  otCharges = 'OT charges',
  others = 'Others',
  professionalFeesCharges = 'Professional fees charges',
  investigation = 'Investigation',
  medicineConsumables = 'Medicine & consumables',
  surgeonAnesthetist = 'Surgeon & anesthetist',
  otherHospitalExpenses = 'Other hospital expenses',
  icuCharges = 'ICU Charges',
  highRiskCharges = 'High Risk Charges',
  ambulance = 'Ambulance Charges',
  bloodCharges = 'Blood Charges',
  cathlab = 'Cathlab Charges',
  implantsCharges = 'Implants Charges',
  diabeticCharges = 'Diabetic Charges',
  medicalEquimentCharges = 'Medical Equipment',
  foodCharges = 'Food & Beverages',
  professionalCharges = 'Professional Fees',
  selectPackage = 'Package_charges',
  selectRoomRent= 'Room_rent_Nursing_charges',
  selectConsultation = 'Consultation_charges',
  selectOT = 'OT_charges',
  selectICU = 'ICU_Charges',
  selectHighRisk= 'High_Risk_Charges',
  selectAnashthesia= 'Surgeon_anesthetist',
  selectInvestigation = 'Investigation_charges',
  selectMedicine = 'Medicine_consumables',
  selectOtherExpenses = 'Other_hospital_expenses',
  selectAmbulance = 'Ambulance_Charges',
  selectBloodCharges = 'Blood_Charges',
  selectFoodCharges = 'Food_Beverages',
  selectProfessionalFees = 'Professional_Fees',
  selectMedicalEquip = 'Medical_Equipment',
  selectCathlab = 'Cathlab_Charges',
  selectImplants = 'Implants_charges',
  selectDiabetic = 'Diabetic_Charges',
  estimatedCost = 'Estimated Cost',
  anhPackage = 'ANH_Package',
}

export const BILL_DETAIL_EMAIL = [
  {
    billPackageId: 0,
    billPackageName: 'Room rent & Nursing charges',
    billDropDownName: 'Room_rent_Nursing_charges',
    billLevel1CategoryCode: '100000',
    billLevel1CategoryName: 'Room & Nursing Charges',
    billLevel2CategoryCode: '101000',
    billLevel2CategoryName: 'Room & Nursing Charges',
    billLevel3CategoryCode: '101003',
    billLevel3CategoryName: 'Room & Nursing Charges',
    isEdit: true,
    isRequired: false,
  },
  {
    billPackageId: 0,
    billPackageName: 'Estimated Cost',
    billLevel1CategoryCode: '999999',
    billLevel1CategoryName: 'Estimated Cost',
    billLevel2CategoryCode: '999999',
    billLevel2CategoryName: 'Estimated Cost',
    billLevel3CategoryCode: '999999',
    billLevel3CategoryName: 'Estimated Cost',
    isEdit: true,
    isRequired: false,
  },
   {
    billPackageId: 0,
    billPackageName: 'OT charges',
    billDropDownName: 'OT_charges',
    isEdit: true,
    isRequired: false,
    billLevel1CategoryCode: '300000',
    billLevel1CategoryName: 'OT Charges',
    billLevel2CategoryCode: '301000',
    billLevel2CategoryName: 'OT rent',
    billLevel3CategoryCode: '301000',
    billLevel3CategoryName: 'OT rent',
  }, {
    billPackageId: 0,
    billPackageName: 'Surgeon & anesthetist',
    billDropDownName: 'Surgeon_anesthetist',
    isEdit: true,
    billLevel1CategoryCode: '500000',
    billLevel1CategoryName: 'Professional fees charges',
    billLevel2CategoryCode: '502000',
    billLevel2CategoryName: 'Surgery Charges',
    billLevel3CategoryCode: '502001',
    billLevel3CategoryName: 'Surgeons Charges',
    isRequired: false,
  }, {
    billPackageId: 0,
    billPackageName: 'Investigations',
    billDropDownName: 'Investigation_charges',
    isEdit: true,
    billLevel1CategoryCode: '600000',
    billLevel1CategoryName: 'Investigation Charges',
    billLevel2CategoryCode: '601000',
    billLevel2CategoryName: 'Bio Chemistry Serum Sodium, Ueres etc',
    billLevel3CategoryCode: '601001',
    billLevel3CategoryName: 'Bio Chemistry Serum Sodium, Ueres etc',
  }, {
    billPackageId: 0,
    billPackageName: 'ICU Charges',
    billDropDownName: 'ICU Charges',
    isEdit: true,
    isRequired: false,
    billLevel1CategoryCode: '999999',
    billLevel1CategoryName: 'ICU Charges',
    billLevel2CategoryCode: '999999',
    billLevel2CategoryName: 'ICU Charges',
    billLevel3CategoryCode: '999999',
    billLevel3CategoryName: 'ICU Charges',
  }, {
    billPackageId: 0,
    billPackageName: 'Other hospital expenses',
    billDropDownName: 'Other_hospital_expenses',
    isEdit: true,
    isRequired: false,
    billLevel1CategoryCode: '800000',
    billLevel1CategoryName: 'Miscellaneous charges',
    billLevel2CategoryCode: '800000',
    billLevel2CategoryName: 'Miscellaneous charges',
    billLevel3CategoryCode: '800000',
    billLevel3CategoryName: 'Miscellaneous charges',
  },
];
export const BILL_DETAIL = [

  {
    billPackageId: 0,
    billPackageName: 'Package',
    billDropDownName: 'Package_charges',
    isEdit: true,
    isRequired: false,
    billLevel1CategoryCode: '900000',
    billLevel1CategoryName: 'Package Charges',
    billLevel2CategoryCode: '900000',
    billLevel2CategoryName: 'Package Charges',
    billLevel3CategoryCode: '900000',
    billLevel3CategoryName: 'Package Charges',
  },
  {
    billPackageId: 0,
    billPackageName: 'Room rent & Nursing charges',
    billDropDownName: 'Room_rent_Nursing_charges',
    isEdit: true,
    isRequired: true,
    billLevel1CategoryCode: '100000',
    billLevel1CategoryName: 'Room & Nursing Charges',
    billLevel2CategoryCode: '101000',
    billLevel2CategoryName: 'Room & Nursing Charges',
    billLevel3CategoryCode: '101003',
    billLevel3CategoryName: 'Room & Nursing Charges',
  },
  {
    billPackageId: 0,
    billPackageName: 'Nursing Charge',
    billDropDownName: 'Nursing_Charges',
    isEdit: true,
    isRequired: false,
    billLevel1CategoryCode: '100000',
    billLevel1CategoryName: 'Room & Nursing Charges',
    billLevel2CategoryCode: '101000',
    billLevel2CategoryName: 'Room & Nursing Charges',
    billLevel3CategoryCode: '102000',
    billLevel3CategoryName: 'Nursing Charges',
  },
  {
    billPackageId: 0,
    billPackageName: 'ANH_Package',
    billDropDownName: 'ANH_Package_Charges',
    isEdit: true,
    isRequired: false,
    billLevel1CategoryCode: '800004',
    billLevel1CategoryName: 'ANH Package Charges',
    billLevel2CategoryCode: '800004',
    billLevel2CategoryName: 'ANH Package Charges',
    billLevel3CategoryCode: '800004',
    billLevel3CategoryName: 'ANH Package Charges',
  },
  {
    billPackageId: 0,
    billPackageName: 'Consultation',
    billDropDownName: 'Consultation_charges',
    isEdit: true,
    billLevel1CategoryCode: '500000',
    billLevel1CategoryName: 'Professional fees charges',
    billLevel2CategoryCode: '501000',
    billLevel2CategoryName: 'Visit charges',
    billLevel3CategoryCode: '501001',
    billLevel3CategoryName: 'Consultation Charges',
  },
  {
    billPackageId: 0,
    billPackageName: 'OT charges',
    billDropDownName: 'OT_charges',
    isEdit: true,
    billLevel1CategoryCode: '300000',
    billLevel1CategoryName: 'OT Charges',
    billLevel2CategoryCode: '301000',
    billLevel2CategoryName: 'OT rent',
    billLevel3CategoryCode: '301000',
    billLevel3CategoryName: 'OT rent',
  },
  {
    billPackageId: 0,
    billPackageName: 'Professional Fees',
    billDropDownName: 'Professional_Fees',
    isEdit: true,
    isRequired: undefined,
    billLevel1CategoryCode: '0',
    billLevel1CategoryName: '',
    billLevel2CategoryCode: '501003',
    billLevel2CategoryName: 'Professional fees',
    billLevel3CategoryCode: '0',
    billLevel3CategoryName: '',
  }, {
    billPackageId: 0,
    billPackageName: 'Surgeon & anesthetist',
    billDropDownName: 'Surgeon_anesthetist',
    isEdit: true,
    billLevel1CategoryCode: '500000',
    billLevel1CategoryName: 'Professional fees charges',
    billLevel2CategoryCode: '502000',
    billLevel2CategoryName: 'Surgery Charges',
    billLevel3CategoryCode: '502001',
    billLevel3CategoryName: 'Surgeons Charges',
  }, {
    billPackageId: 0,
    billPackageName: 'Investigation',
    billDropDownName: 'Investigation_charges',
    isEdit: true,
    billLevel1CategoryCode: '600000',
    billLevel1CategoryName: 'Investigation Charges',
    billLevel2CategoryCode: '601000',
    billLevel2CategoryName: 'Bio Chemistry Serum Sodium, Ueres etc',
    billLevel3CategoryCode: '601001',
    billLevel3CategoryName: 'Bio Chemistry Serum Sodium, Ueres etc',
  },
  {
    billPackageId: 0,
    billPackageName: 'ICU Charges',
    billDropDownName: 'ICU_Charges',
    isEdit: true,
    isRequired: undefined,
    billLevel1CategoryCode: '201000',
    billLevel1CategoryName: 'ICU Charges',
    billLevel2CategoryCode: '201000',
    billLevel2CategoryName: 'ICU Charges',
    billLevel3CategoryCode: '0',
    billLevel3CategoryName: '',
  },
  {
    billPackageId: 0,
    billPackageName: 'Ambulance Charges',
    billDropDownName: 'Ambulance_Charges',
    isEdit: true,
    isRequired: undefined,
    billLevel1CategoryCode: '700000',
    billLevel1CategoryName: 'Ambulance Charges',
    billLevel2CategoryCode: '700000',
    billLevel2CategoryName: 'Ambulance Charges',
    billLevel3CategoryCode: '0',
    billLevel3CategoryName: '',

  },
  {
    billPackageId: 0,
    billPackageName: 'Implants Charges',
    billDropDownName: 'Implants_charges',
    isEdit: true,
    isRequired: undefined,
    billLevel1CategoryCode: '0',
    billLevel1CategoryName: '',
    billLevel2CategoryCode: '303002',
    billLevel2CategoryName: 'Implants',
    billLevel3CategoryCode: '0',
    billLevel3CategoryName: '',
  }, {
    billPackageId: 0,
    billPackageName: 'Medicine & consumables',
    billDropDownName: 'Medicine_consumables',
    isEdit: true,
    isRequired: undefined,
    billLevel1CategoryCode: '400000',
    billLevel1CategoryName: 'Medicine & Consumables',
    billLevel2CategoryCode: '401000',
    billLevel2CategoryName: 'Medicine & charges Consumables',
    billLevel3CategoryCode: '401000',
    billLevel3CategoryName: 'Medicine & charges Consumables',

  }, {
    billPackageId: 0,
    billPackageName: 'Other hospital expenses',
    billDropDownName: 'Other_hospital_expenses',
    isEdit: true,
    billLevel1CategoryCode: '800000',
    billLevel1CategoryName: 'Miscellaneous charges',
    billLevel2CategoryCode: '800000',
    billLevel2CategoryName: 'Miscellaneous charges',
    billLevel3CategoryCode: '800000',
    billLevel3CategoryName: 'Miscellaneous charges',
  },
];
export const BILL_DETAIL_HDFC = [
  {
    billPackageId: 0,
    billPackageName: 'Package',
    billDropDownName: 'Package_charges',
    isEdit: true,
    isRequired: false,
    billLevel1CategoryCode: '900000',
    billLevel1CategoryName: 'Package Charges',
    billLevel2CategoryCode: '900000',
    billLevel2CategoryName: 'Package Charges',
    billLevel3CategoryCode: '900000',
    billLevel3CategoryName: 'Package Charges',
  },
  {
    billPackageId: 0,
    billPackageName: 'Total rent',
    billDropDownName: 'Room_rent_Nursing_charges',
    isEdit: true,
    isRequired: true,
    billLevel1CategoryCode: '100000',
    billLevel1CategoryName: 'Room & Nursing Charges',
    billLevel2CategoryCode: '101000',
    billLevel2CategoryName: 'Room & Nursing Charges',
    billLevel3CategoryCode: '101000',
    billLevel3CategoryName: 'Room Charges',
  },
  {
    billPackageId: 0,
    billPackageName: 'Nursing Charge',
    billDropDownName: 'Room_rent_Nursing_charges',
    isEdit: true,
    isRequired: false,
    billLevel1CategoryCode: '100000',
    billLevel1CategoryName: 'Room & Nursing Charges',
    billLevel2CategoryCode: '101000',
    billLevel2CategoryName: 'Room & Nursing Charges',
    billLevel3CategoryCode: '102000',
    billLevel3CategoryName: 'Nursing Charges',
  },
  {
    billPackageId: 0,
    billPackageName: 'Physician Charge',
    billDropDownName: 'Consultation_charges',
    isEdit: false,
    isRequired: false,
    billLevel1CategoryCode: '500000',
    billLevel1CategoryName: 'Professional fees charges',
    billLevel2CategoryCode: '501000',
    billLevel2CategoryName: 'Visit charges',
    billLevel3CategoryCode: '501001',
    billLevel3CategoryName: 'Consultation Charges',
  },
  {
    billPackageId: 0,
    billPackageName: 'Surgeon Charge',
    billDropDownName: 'Consultation_charges',
    isEdit: true,
    isRequired: false,
    billLevel1CategoryCode: '500000',
    billLevel1CategoryName: 'Professional fees charges',
    billLevel2CategoryCode: '501000',
    billLevel2CategoryName: 'Visit charges',
    billLevel3CategoryCode: '502001',
    billLevel3CategoryName: 'Surgeons Charges',
  },
   {
    billPackageId: 0,
    billPackageName: 'OT charges',
    billDropDownName: 'OT_charges',
    isEdit: true,
    billLevel1CategoryCode: '300000',
    billLevel1CategoryName: 'OT Charges',
    billLevel2CategoryCode: '301000',
    billLevel2CategoryName: 'OT rent',
    billLevel3CategoryCode: '301000',
    billLevel3CategoryName: 'Defibrillator Charges',
  }, {
    billPackageId: 0,
    billPackageName: 'Anesthetist',
    billDropDownName: 'Surgeon_anesthetist',
    isEdit: true,
    billLevel1CategoryCode: '500000',
    billLevel1CategoryName: 'Professional fees charges',
    billLevel2CategoryCode: '502000',
    billLevel2CategoryName: 'Assistant Surgeon Charges',
    billLevel3CategoryCode: '502002',
    billLevel3CategoryName: 'Assistant Surgeons Charges',
  }, {
    billPackageId: 0,
    billPackageName: 'Investigations',
    billDropDownName: 'Investigation_charges',
    isEdit: true,
    billLevel1CategoryCode: '600000',
    billLevel1CategoryName: 'Investigation Charges',
    billLevel2CategoryCode: '601000',
    billLevel2CategoryName: 'Bio Chemistry Serum Sodium, Ueres etc',
    billLevel3CategoryCode: '601000',
    billLevel3CategoryName: 'Bio Chemistry',
  }, {
    billPackageId: 0,
    billPackageName: 'Consumables',
    billDropDownName: 'Medicine_consumables',
    isEdit: true,
    isRequired: undefined,
    billLevel1CategoryCode: '400000',
    billLevel1CategoryName: 'Medicine & Consumables',
    billLevel2CategoryCode: '401000',
    billLevel2CategoryName: 'Medicine & charges Consumables',
    billLevel3CategoryCode: '401002',
    billLevel3CategoryName: 'Ward Consumables',

  }, {
    billPackageId: 0,
    billPackageName: 'Pharmacy',
    billDropDownName: 'Medicine_consumables',
    isEdit: true,
    isRequired: undefined,
    billLevel1CategoryCode: '400000',
    billLevel1CategoryName: 'Medicine & Consumables',
    billLevel2CategoryCode: '401000',
    billLevel2CategoryName: 'Medicine & charges Consumables',
    billLevel3CategoryCode: '401000',
    billLevel3CategoryName: 'Medicine & charges Consumables',

   }, {
    billPackageId: 0,
    billPackageName: 'Others',
    billDropDownName: 'Other_hospital_expenses',
    isEdit: true,
    billLevel1CategoryCode: '800000',
    billLevel1CategoryName: 'Miscellaneous charges',
    billLevel2CategoryCode: '800000',
    billLevel2CategoryName: 'Miscellaneous charges',
    billLevel3CategoryCode: '800000',
    billLevel3CategoryName: 'Miscellaneous charges',
  },
];
export const RPA_BILL_DETAIL = BILL_DETAIL.concat([
  {
    billPackageId: 0,
    billPackageName: 'High Risk Charges',
    billDropDownName: 'High_Risk_Charges',
    isEdit: true,
    isRequired: undefined,
    billLevel1CategoryCode: '0',
    billLevel1CategoryName: '',
    billLevel2CategoryCode: '800000',
    billLevel2CategoryName: 'Miscellaneous charges',
    billLevel3CategoryCode: '0',
    billLevel3CategoryName: '',

  },
  {
    billPackageId: 0,
    billPackageName: 'Blood Charges',
    billDropDownName: 'Blood_Charges',
    isEdit: true,
    isRequired: undefined,
    billLevel1CategoryCode: '0',
    billLevel1CategoryName: '',
    billLevel2CategoryCode: '102007',
    billLevel2CategoryName: 'Blood Transfusion Charges',
    billLevel3CategoryCode: '0',
    billLevel3CategoryName: '',

  },
  {
    billPackageId: 0,
    billPackageName: 'Cathlab Charges',
    billDropDownName: 'Cathlab_Charges',
    isEdit: true,
    isRequired: undefined,
    billLevel1CategoryCode: '300000',
    billLevel1CategoryName: 'OT Charges',
    billLevel2CategoryCode: '301003',
    billLevel2CategoryName: 'Cath Lab Charges',
    billLevel3CategoryCode: '0',
    billLevel3CategoryName: '',
  },
  {
    billPackageId: 0,
    billPackageName: 'Diabetic Charges',
    billDropDownName: 'Diabetic_Charges',
    isEdit: true,
    isRequired: undefined,
    billLevel1CategoryCode: '0',
    billLevel1CategoryName: '',
    billLevel2CategoryCode: '800000',
    billLevel2CategoryName: 'Miscellaneous charges',
    billLevel3CategoryCode: '0',
    billLevel3CategoryName: '',

  },
  {
    billPackageId: 0,
    billPackageName: 'Medical Equipment',
    billDropDownName: 'Medical_Equipment',
    isEdit: true,
    isRequired: undefined,
    billLevel1CategoryCode: '0',
    billLevel1CategoryName: '',
    billLevel2CategoryCode: '501002',
    billLevel2CategoryName: 'Medical Supervision Charges',
    billLevel3CategoryCode: '0',
    billLevel3CategoryName: '',
  },
  {
    billPackageId: 0,
    billPackageName: 'Food & Beverages',
    billDropDownName: 'Food_Beverages',
    isEdit: true,
    isRequired: undefined,
    billLevel1CategoryCode: '0',
    billLevel1CategoryName: '',
    billLevel2CategoryCode: '802000',
    billLevel2CategoryName: 'Attendant food charges',
    billLevel3CategoryCode: '0',
    billLevel3CategoryName: '',
  },
] as any);

export const BILL_PACKAGE_NAME = (isRpa?: boolean, shortName?: any): any[] =>
  (isRpa ? RPA_BILL_DETAIL : (shortName === 'HDFC' && process.env.REACT_APP_HDFC_FEATURES === 'true') ? BILL_DETAIL_HDFC :
    BILL_DETAIL).map(({ billPackageName }: any): string => billPackageName);

export const APPOINTMENT_CATEGORY = [
  { id: 50000, name: 'HEALTHCHECK', CategoryTypeId: ' 2659CE0B-AC67-4BF7-83CD-334A4447AEDF' },
  { id: 50001, name: 'CONSULTATION', CategoryTypeId: 'D2BEABBB-D891-4A86-8297-26B006D0861F' },
  { id: 50002, name: 'DIAGNOSTICS', CategoryTypeId: '1D70A7DA-654C-4396-A411-F098C0F3F376' },
  { id: 50003, name: 'MEDICINE', CategoryTypeId: 'E80CD81A-74D8-4CEB-BD37-E057DC4A4AF7' },
];

export const APPOINTMENT_CATEGORY_DISPLAY = ['HEALTHCHECK', 'CONSULTATION', 'DIAGNOSTICS', 'MEDICINE'];

export const DOCTOR_QUALIFICATION_DROPDOWN = ['MBBS', 'MD', 'MS', 'Others'];

export const OUT_PATIENT_COLUMNS = [
  {
    title: 'Request ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Name',
    dataIndex: 'patientName',
    key: 'patientName',
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: 'Service',
    key: 'serviceType',
    dataIndex: 'serviceType',
  },
  {
    title: 'Status',
    dataIndex: 'currentStatus',
    key: 'currentStatus',
  },
  {
    title: 'Appointment date',
    dataIndex: 'fulfillmentDate',
    key: 'fulfillmentDate',
    render: (date: any): any => (
      date && getDateWithTextMonth(date)
    ),
  }, {
    title: 'Action',
    dataIndex: 'nextActions',
    key: 'nextActions',
    render: (text: any, record: any): any => <FrontDeskActions text={text} record={record} />,
  },
];

export const SELECT_TEXT = '--Select--';

export const DC_roles = ['DC_Admin', 'DC_Finance', 'DC_Operations'];

export const normal_roles = ['Admin', 'Finance', 'Operations'];

export enum FrontDeskAction {
  CONFIRM = 'Confirm',
  RESCHEDULE = 'Reschedule',
  CANCEL = 'Cancel',
  ATTENDED = 'Attended',
  NOT_ATTENDED = 'NotAttended',
}

export const ALL = 'All';
export const UNFILTERED_DATA_TYPE = 'unFiltered';
export const FILTERED_DATA_TYPE = 'filtered';
export const ADMISSION_TITLE = 'Claims Management';
export const CLAIMS_LISTING = 'Claims Listing';
export const SEARCH_PLACEHOLDER = 'UTR Search';
export const CLAIM_NUMBER_SEARCH_PLACEHOLDER = 'Claim No. Search';
export const PRIMARY_BUTTON_TYPE = 'primary';
export const TABLE_SIZE_MIDDLE = 'middle';
export const ADMISSION_TYPES = [{ name: 'Emergency', value: 'emergency' }, { name: 'Planned', value: 'planned' }];
export const APPOINTEMENT_TITLE = 'Appointment';
export const BY_HAND = 'By Hand';
export const BY_COURIER = 'By Courier';

export const MATERNITY_TYPE = [{
  id: 4455,
  parentId: 471,
  name: 'Normal Delivery',
  code: 'O80',
  value: 4455,
},
{
  id: 3240,
  parentId: 498,
  name: 'C-Section',
  code: 'O82',
  value: 3240,
}];

export const CATARACT_TYPE = [{
  'id': 8933,
  'value': 8933,
  'code': 'H25.011',
  'packageCode': 'H25',
  'name': 'Right Eye',
  'isSelected': null,
  'ageStartLimit': 18,
  'ageEndLimit': 100,
  'treatmentType': [{
    'id': 281,
    'name': 'Femto Laser Surgery',
  }, {
    'id': 1,
    'name': 'Surgical Management',
  }, {
    'id': 3467,
    'name': 'Phaco emulsification(PHACO)',
  }, {
    'id': 141,
    'name': 'MICS',
  }],
}, {
  'id': 8934,
  'value': 8934,
  'code': 'H25.012',
  'packageCode': 'H26',
  'name': 'Left Eye',
  'isSelected': null,
  'ageStartLimit': 18,
  'ageEndLimit': 100,
  'treatmentType': [{
    'id': 1,
    'name': 'Surgical Management',
  }, {
    'id': 3467,
    'name': 'Phaco emulsification(PHACO)',
  }, {
    'id': 141,
    'name': 'MICS',
  }],
}, {
  'id': 8967,
  'value': 8967,
  'code': 'H26.011',
  'packageCode': 'H25',
  'name': 'Right Eye',
  'isSelected': null,
  'ageStartLimit': 0,
  'ageEndLimit': 17,
  'treatmentType': [{
    'id': 281,
    'name': 'Femto Laser Surgery',
  }, {
    'id': 1,
    'name': 'Surgical Management',
  }, {
    'id': 3467,
    'name': 'Phaco emulsification(PHACO)',
  }, {
    'id': 141,
    'name': 'MICS',
  }],
}, {
  'id': 8968,
  'value': 8968,
  'code': 'H26.012',
  'packageCode': 'H26',
  'name': 'Left Eye',
  'isSelected': null,
  'ageStartLimit': 0,
  'ageEndLimit': 17,
  'treatmentType': [{
    'id': 1,
    'name': 'Surgical Management',
  }, {
    'id': 3467,
    'name': 'Phaco emulsification(PHACO)',
  }, {
    'id': 141,
    'name': 'MICS',
  }],
}];

export const CATARACT_LENS_TYPE = [{
  'id': 148,
  'parentId': 0,
  'name': 'Monofocal',
  'value': 148,
},
{
  'id': 149,
  'parentId': 0,
  'name': 'Aspheric',
  'value': 149,
},
{
  'id': 150,
  'parentId': 0,
  'name': 'Monofocal + Aspheric Toric',
  'value': 150,
},
{
  'id': 151,
  'parentId': 0,
  'name': 'Monofocal + Toric',
  'value': 151,
},
{
  'id': 152,
  'parentId': 0,
  'name': 'Multifocal',
  'value': 152,
},
];

export const OTHER_ID = '9999999999';

export const PROCEDURE_OTHER_TYPES = [{
  label: 'Others',
  name: 'Others',
  value: '9999999999',
  id: 9999999999,
  procedure: 'Others',
}];

export const OTHER_ROOM_TYPE = [
  {
    label: 'Others',
    name: 'Others',
    value: '9999999999',
    id: 9999999999,
    procedure: 'Others',
  },
];

export const PAYER_ROOM_MAPPING = {
  GENERAL_WARD: 'General/Economy ward',
  SEMI_PVT_WARD: 'Semi private room',
  PVT_WARD: 'Single private room',
  DELUXE_OTHER: 'Deluxe room',
};

export const OBSTETRIC_HISTORY = ['G', 'P', 'L', 'A', 'D'];

export const FINAL_OBSTETRIC_HISTORY = OBSTETRIC_HISTORY.map((ele: string): string => `obstetricHistory${ele}`);

export const DIAGNOSIS_TYPE = ['Maternity', 'Cataract', 'Accident', 'Illness', 'Other'];

export const SUBMIT_ENBLED_PAYERS = ['516572', '522920', '516571', '523844', '523850'];

export enum actions {
  DISCHARGE = 'DISCHARGE',
  ENHANCEMENT = 'ENHANCEMENT',
  CASHLESSSUMBIT = 'CASHLESSSUMBIT',
  UPDATE = 'UPDATE',
  RECONSIDERATION = 'RECONSIDERATION',
  CANCEL = 'CANCEL',
  SUBMITINFO = 'SUBMITINFO',
  CONFIRMATION = 'CONFIRMATION',
  EDIT = 'EDIT',
  SUBMISSIONDISABLED = 'SUBMISSIONDISABLED',
  ENHANCEMENTQUERYREPLIED = 'ENHANCEMENTQUERYREPLIED',
  DISCHARGEQUERYREPLIED = 'DISCHARGEQUERYREPLIED',
  REIMBURSEMENTQUERYREPLIED = 'REIMBURSEMENTQUERYREPLIED',
  CLAIMQUERYREPLIED = 'CLAIMQUERYREPLIED',
  RECONSIDER = 'RECONSIDER',
  EASYDISCHARGEINITIATED= 'EASYDISCHARGEINITIATED',
  EASYDISCHARGEQUERYREPLIED = 'EASYDISCHARGEQUERYREPLIED',
  ACKNOWLEDGEPAYMENT = 'ACKNOWLEDGEPAYMENT',
  DISCHARGECONTEST = 'DISCHARGECONTEST',
}

export enum ctaActionNames {
  CANCEL = 'Cancel',
  DISCHARGE = 'Discharge',
  ENHANCE = 'Enhance',
  RECONSIDER = 'Reconsider',
  QUERY = 'Query Response',
  SETTLEMENT = 'Initiate settlement',
  EARLYDISCHARGE = 'Early Discharge',
  EARLYDISCHARGEqUERY = 'Early Discharge Query',
  WITHDRAW = 'Withdraw',
  PAYMENTACKNOWLEDGEMENT = 'Payment Acknowledgement',
  RESUBMIT = 'Re-Submit',
  EDIT = 'Edit',
  DELETE = 'Delete',
  ACTIVATEHEALTHVAULT = 'Activate HealthVault',
  CANCELLATION = 'CANCEL',
  CANCELLING = 'cancelling',
  WITHDRAWING = 'withdrawing',
  CANCELLED = 'cancelled',
  WITHDRAWN = 'withdrawn',
  DISCHARGECONTEST = 'Discharge Contest',
  DISCHARGE_CONTEST_ACTION = 'DISCHARGECONTEST',
}

export const USER_ACTIONS: Record<number, string> = {
  1: 'NEWADMISSION',
  3: 'ENHANCE',
  6: 'QUERY',
  8: 'DISCHARGE',
  10: 'SETTLEMENT',   // intitate settlement
  13: 'CANCEL',
  25: 'RECONSIDER',
  28: 'UPDATE',
  32: 'CONFIRMATION',
  41: 'QUERY',
  43: 'QUERY',
  52: 'SETTLEMENT',   // claim query replied
  53: 'RECONSIDER',
  54: 'EASYDISCHARGEINITIATED',
  58: 'EASYDISCHARGEQUERYREPLIED',
  94: 'CANCEL',
  114: 'INITIALDISCHARGE',
  999: 'VIEWCLAIM',
} as const;

export const ENHANCEMENT_DISCHARGE_ACTION = [actions.DISCHARGE, actions.ENHANCEMENT];

export const ACTION_ADMISSION_SUBMIT = [
  actions.DISCHARGE, actions.ENHANCEMENT, actions.CASHLESSSUMBIT, actions.UPDATE,
  actions.RECONSIDERATION, actions.CANCEL, actions.SUBMITINFO, actions.CONFIRMATION,
  actions.ENHANCEMENTQUERYREPLIED, actions.DISCHARGEQUERYREPLIED,
   actions.CLAIMQUERYREPLIED, actions.RECONSIDER,
  actions.EASYDISCHARGEINITIATED, actions.EASYDISCHARGEQUERYREPLIED, actions.DISCHARGECONTEST,
];

export const ACTION_CORPORATE_EDIT = [
  actions.ENHANCEMENT, actions.EDIT,
];

export const OTHERTHEN_DISCHARGE = [
  actions.CANCEL, actions.RECONSIDERATION, actions.UPDATE,
  actions.SUBMITINFO, actions.CONFIRMATION,
];

export const ACTION_REIMBURSEMENT = [
  actions.REIMBURSEMENTQUERYREPLIED,
];

export const DEFAULT_TIMELINE = [
  {
    title: 'New Admission', remarks: 'Initiating...', date: import('../../utils/dateTimeUtils')
      .then((dateTimeUtils: any): any => {
        dateTimeUtils.getDateWithTime();
      }),
  },
];

export enum IN_PATIENT_PAGE_NAME {
  newAdmission = 'new-admission',
  detail = 'detail',
  edit = 'edit',
  discharge = 'discharge',
  reconsider = 'reconsider',
  grievance = 'grievance',
  cancel = 'cancel',
}

export const SUCCESS = 'Success';
export const ERROR = 'Error';
export const ERROR_MODAL = 'Error Modal';
export const BOTTOM_RIGHT_POSITION = 'bottomRight';

export const mandatoryClassificationInfo: Record<string, { questionType: string; questionText: string; attemptId: number }> = {
  kyc: {
    questionType: 'kyc',
    questionText: 'Have you uploaded KYC?',
    attemptId: 1,
  },
  discharge_summary: {
    questionType: 'discharge_summary',
    questionText: 'Have you uploaded Discharge Summary?',
    attemptId: 1,
  },
  bill: {
    questionType: 'bill',
    questionText: 'Have you uploaded Bill?',
    attemptId: 1,
  },
  a_scan_or_doctor_notes: {
    questionType: 'a_scan_or_doctor_notes',
    questionText: 'Have you uploaded A Scan or any Doctor Notes?',
    attemptId: 1,
  },
  usg_scan_or_doctor_notes: {
    questionType: 'usg_scan_or_doctor_notes',
    questionText: 'Have you uploaded USG Scan or any Doctor Notes?',
    attemptId: 1,
  },
  doctor_notes: {
    questionType: 'doctor_notes',
    questionText: 'Have you uploaded Doctor Notes?',
    attemptId: 1,
  },
  pan: {
    questionType: 'pan',
    questionText: 'Have you uploaded Pan Card?',
    attemptId: 1,
  },
  claim_form: {
    questionType: 'claim_form',
    questionText: 'Have you uploaded Claim Form?',
    attemptId: 1,
  },
  declaration_form: {
    questionType: 'declaration_form',
    questionText: 'Have you uploaded Declaration Form?',
    attemptId: 1,
  },
  usg_abdomen_pregnancy_report : {
    questionType: 'usg_abdomen_pregnancy_report',
    questionText: 'Have you uploaded USG Abdomen Pregnancy Report?',
    attemptId: 1,
  },
  otoscopy_audiometry_audiogram: {
    questionType: 'otoscopy_audiometry_audiogram',
    questionText: 'Have you uploaded Otpscopy Form?',
    attemptId: 1,
  },
  mri_scan: {
    questionType: 'mri_scan',
    questionText: 'Have you uploaded MRI Scan?',
    attemptId: 1,
  },
  a_scan_report_to_support_diagnosis_new: {
    questionType: 'A-SCAN report to support diagnosis',
    questionText: 'Have you uploaded A-SCAN Report to support Diagnosis?',
    attemptId: 1,
  },
  estimated_bill_as_per_agreed_tariff: {
    questionType: 'Estimated bill as per agreed tariff (as applicable)',
    questionText: 'Have you uploaded Estimated Bill as per Agreed Tariff?',
    attemptId: 1,
  },
  patients_ID_Proof: {
    questionType: 'Patients ID Proof',
    questionText: 'Have you uploaded Patient\'s ID Proof?',
    attemptId: 1,
  },
  Pre_auth_claim_form: {
    questionType: 'Pre-auth/claim form',
    questionText: 'Have you uploaded Pre-Auth/Claim Form mentioning Duration of Ailment and Cost Estimate?',
    attemptId: 1,
  },
  declaration_form_GIPSA_certificate: {
    questionType: 'Declaration form/GIPSA certificate',
    questionText: 'Have you uploaded Declaration Form/GIPSA Certificate?',
    attemptId: 1,
  },
  detailed_bill_as_per_agreed_tariff: {
    questionType: 'Detailed bill as per agreed tariff (as applicable)',
    questionText: 'Have you uploaded Detailed Bill as per Agreed Tariff?',
    attemptId: 1,
  },
  sticker_of_implant: {
    questionType: 'Sticker of implant (IOL)',
    questionText: 'Have you uploaded Sticker of Implant (IOL)?',
    attemptId: 1,
  },
  invoice_copy_of_implant: {
    questionType: 'Invoice copy of implant',
    questionText: 'Have you uploaded Invoice Copy of Implant?',
    attemptId: 1,
  },
  discharge_summary_additional: {
    questionType: 'Discharge Summary',
    questionText: 'Have you uploaded Discharge Summary?',
    attemptId: 1,
  },
  final_bill_with_break_up_of_its_components: {
    questionType: 'final_bill_with_break_up_of_its_components',
    questionText: 'Have you uploaded Final Bill with Break up of its Components?',
    attemptId: 1,
  },
  all_investigation_reports_lab_reports: {
    questionType: 'all_investigation_reports_lab_reports',
    questionText: 'Have you uploaded All Investigation Reports - Lab Reports?',
    attemptId: 1,
  },
  investigation_reports_films_x_rays_usg_echo_mri_ct_scan_hpe: {
    questionType: 'investigation_reports_films_x_rays_usg_echo_mri_ct_scan_hpe',
    questionText: 'Have you uploaded Investigation Reports - Films - X-Rays/USG/ECHO/MRI/CT Scan/HPE?',
    attemptId: 1,
  },
  operation_theatre_notes: {
    questionType: 'operation_theatre_notes',
    questionText: 'Have you uploaded Operation Theatre Notes?',
    attemptId: 1,
  },
  indoor_case_papers: {
    questionType: 'indoor_case_papers',
    questionText: 'Have you uploaded Indoor Case Papers?',
    attemptId: 1,
  },
  medicine_bills_and_dr_prescriptions: {
    questionType: 'medicine_bills_and_dr_prescriptions',
    questionText: 'Have you uploaded Medicine Bills and Doctor Prescriptions?',
    attemptId: 1,
  },
};
export const ABHI_INITIALDISCHARGE = 'Day care case: Initiating Initial + Discharge. Please submit discharge related documents now or at Settlement.';
export const TIMLINE_MODAL_TABLE_SUBMITTED_COLOR: any = {
  HOSPITAL: 'text-primary',
  TPA: 'text-success-light',
};

export const CRM_INPATIENT_STATUS_COLOUR = [
  {
    statusName: 'New Admission', StatusId: 1, class: 'text-primary',
  }, {
    statusName: 'Pre-Auth Approved', StatusId: 2, class: 'text-success-light',
  }, {
    statusName: 'Enhancement Raised', StatusId: 3, class: ' text-primary',
  }, {
    statusName: 'Enhancement Approved', StatusId: 4, class: 'text-success-light',
  }, {
    statusName: 'Information Required', StatusId: 5, class: 'text-warning',
  }, {
    statusName: 'Information Submitted', StatusId: 6, class: 'text-warning',
  }, {
    statusName: 'Denied', StatusId: 7, class: 'gray-text',
  }, {
    statusName: 'Discharge Documents Submitted', StatusId: 8, class: 'text-primary',
  }, {
    statusName: 'Enhancement Denied', StatusId: 9, class: 'gray-text',
  }, {
    statusName: 'Documents Submitted', StatusId: 10, class: 'text-primary',
  }, {
    statusName: 'Documents Received', StatusId: 11, class: ' text-priamry_light',
  }, {
    statusName: 'Claim Settled', StatusId: 12, class: 'text-success',
  }, {
    statusName: 'Preauth Request Rejected', StatusId: 13, class: 'text-warning',
  }, {
    statusName: 'Claim In Progress', StatusId: 14, class: 'text-priamry_light',
  }, {
    statusName: 'Claim Approved', StatusId: 15, class: 'text-success',
  }, {
    statusName: 'Claim Denied', StatusId: 16, class: 'gray-text',
  }, {
    statusName: 'Claim Information Required', StatusId: 17, class: 'text-warning',
  }, {
    statusName: 'Credit Requested', StatusId: 18, class: 'text-primary',
  }, {
    statusName: 'Credit Request Rejected', StatusId: 19, class: 'text-warning',
  }, {
    statusName: 'Credit Partially Paid', StatusId: 20, class: 'text-success',
  }, {
    statusName: 'Credit Paid', StatusId: 21, class: 'text-priamry_light',
  }, {
    statusName: 'Credit Charges Calculated', StatusId: 22, class: 'text-success-light',
  }, {
    statusName: 'Preauth Utilized', StatusId: 23, class: 'text-success-light',
  }, {
    statusName: 'Loan closed', StatusId: 24, class: 'text-success ',
  }, {
    statusName: 'Reconsideration request', StatusId: 25, class: 'text-warning',
  }, {
    statusName: 'In Progress', StatusId: 26, class: 'text-priamry_light',
  }, {
    statusName: 'Pending for acknowledgement', StatusId: 27, class: 'text-warning',
  }, {
    statusName: 'Update Request Raised', StatusId: 28, class: 'text-priamry_light',
  }, {
    statusName: 'Update Request Received', StatusId: 29, class: 'text-priamry_light',
  }, {
    statusName: 'Update Request Rejected', StatusId: 30, class: 'text-warning',
  }, {
    statusName: 'Claim Received', StatusId: 31, class: 'text-success-light',
  }, {
    statusName: 'Early Discharge Initiated ', StatusId: 54, class: 'text-primary',
  }, {
    statusName: 'Early Discharge Query Replied', StatusId: 58, class: 'text-warning',
  },
];

export const CLEAR_IHAVE_FOR = ['HERITAGE', 'PHSI', 'CMSGI'];

export const POLICY_FIELD_FOR_RPA = ['SHAI', 'NIVA BUPA', 'Bajaj', 'CMSGI', 'ICICI', 'MDSV', 'HERITAGE', 'VOLO', 'PHSI', 'VIDAL'];
export const DIFF_POLICY_OPTIONS_FOR = ['Bajaj', 'NIVA BUPA'];

export const TIME_FOR_MINIMIZE = 5000;
export const STRONG_PASSWORD_ERROR_MESSAGE = 'Entered Password must atleast contain \n1 Upper Case Letter, \n1 Lower Case Letter, \n1 Special Character and \n1 number.';

export const progress = [33, 66, 100];
export const IN_PATIENT_NESTED_ROUTE = (): any[] => {
  const isPreAuthNewDesignEnabled = ApplicationDetail?.instance?.getIsPreAuthNewDesignEnabled();
  const NewAdmissionFlow = isPreAuthNewDesignEnabled ? NewAdmissionRedesign : NewAdmission;
  return [
    {
      tabName: 'New Admission',
      routeName: 'new-admission',
      Component: NewAdmissionFlow,
      accessCheckKeyword: features.NEW_ADMISSION,
    }, {
      tabName: 'Edit Admission',
      routeName: 'detail/:claimDetail/edit/:actionName?',
      Component: NewAdmission,
      accessCheckKeyword: features.EDIT_ADMISSION,
    }, {
      tabName: 'Edit Admission',
      routeName: 'detail/:claimDetail/discharge/:actionName?',
      Component: NewAdmission,
      accessCheckKeyword: features.EDIT_ADMISSION,
    }, {
      tabName: 'Edit Admission',
      routeName: 'detail/:claimDetail/reconsider/:actionName?',
      Component: NewAdmission,
      accessCheckKeyword: features.EDIT_ADMISSION,
    }, {
      tabName: 'Edit Admission',
      routeName: 'detail/:claimDetail/cancel/:actionName?',
      Component: Detail,
      accessCheckKeyword: NOTREQUIRED,
    }, {
      tabName: 'Detail',
      routeName: 'detail/:claimDetail',
      Component: Detail,
      accessCheckKeyword: NOTREQUIRED,
    }, {
      tabName: 'List',
      routeName: '/',
      Component: List,
      accessCheckKeyword: NOTREQUIRED,
    },
  ];
};

export const MATERNITY_DIAGNOSIS_TYPE = ['O80', 'O82', 'O80.0', 'O82.0'];
export const HDFC_MATERNITY_DIAGNOSIS_TYPE = ['O80', 'O82', 'O80.0', 'O82.0', 'O82.1', 'O82.2', 'O82.3',
  'O82.4', 'O82.5', 'O82.6', 'O82.7', 'O82.8',
  'O82.9', 'O80.1', 'O80.2', 'O80.3', 'O80.4', 'O80.5', 'O80.6', 'O80.7', 'O80.8', 'O80.9'];
export const CATARACT_DIAGNOSIS_TYPE = ['H25', 'H26', 'H25.012', 'H25.011'];
export const DIALYSIS_DIAGNOSIS_TYPE = ['N17', 'N18.1'];
export const HYSTERECTOMY_DIAGNOSIS_TYPE = ['N85.9'];
export const ADENOTONSILLECTOMY_DIAGNOSIS_TYPE = ['J03.9'];
export const Haemorrhoidectomy_DIAGNOSIS_TYPE = ['I84'];
export const Appendicectomy_DIAGNOSIS_TYPE = ['K35.89'];
export const Cholecystectomy_DIAGNOSIS_TYPE = ['K81.0'];
export const URSwithDJ_DIAGNOSIS_TYPE = ['N20.2'];

export const CONCATED_OTHER_TREATMENT_ICDS = CATARACT_DIAGNOSIS_TYPE.concat(
  MATERNITY_DIAGNOSIS_TYPE,
  DIALYSIS_DIAGNOSIS_TYPE,
  HYSTERECTOMY_DIAGNOSIS_TYPE,
  ADENOTONSILLECTOMY_DIAGNOSIS_TYPE,
  Haemorrhoidectomy_DIAGNOSIS_TYPE,
  Appendicectomy_DIAGNOSIS_TYPE,
  Cholecystectomy_DIAGNOSIS_TYPE,
  URSwithDJ_DIAGNOSIS_TYPE,
);

export const DEFAULT_OPTIONS_FOR_APPROACH = {
  'N85.9': ['Open', 'Laparoscopic'],
  'J03.9': ['Conventional', 'Coblation'],
  'I84': ['Conventional', 'Stapled', 'Laser'],
  'H25.012': ['Conventional', 'MICS', 'SICS', 'Laser'],
  'H25.011': ['Conventional', 'MICS', 'SICS', 'Laser'],
};

export const DEFAULT_OPTIONS_FOR_POSITION = {
  'N85.9': ['Vaginal', 'Abdominal'],
  'N20.2': ['Left', 'Right'],
};

export enum EXTENDED_STATUS {
  uploading = 'uploading',
  uploaded = 'uploaded',
  verifying = 'verifying',
  verified = 'verified',
}

export enum UPLOAD_STATUS {
  uploading = 'uploading',
  done = 'done',
  error = 'error',
}

export const NEW_UPLOAD_STATUS = 'New uploads';

export const HIS_UPLOAD_STATUS = 'HIS Uploads';

export const HANDLE_IN_BUDDHIMED_MODAL = [actions.SUBMITINFO];
export const FILE_UPLOAD_ERROR_MESSAGE = 'Please upload at-least 1 file.';
export const NON_AGREE_ERROR_MESSAGE = 'Click on I agree to cancel a claim.';
export const INPATIENT_LIST_PAGERANGE = 10;
export const MIN_NUMBERS_OF_IP_COLS = 6;
export const MAX_NUMBERS_OF_IP_COLS = 8;
export const MIN_NUMBERS_OF_CLAIMS_DISPLAY_COLS = 5;
export const MAX_NUMBERS_OF_CLAIMS_DISPLAY_COLS = 6;

export const MAX_LOS_ALLOWED_WITHOUT_WARNING = 90;

export const TAG_LIST_NAME = [
  {
    name: 'Draft',
    id: 'DRAFT',
  },
  {
    name: 'Pre-Auth Query',
    id: 'SUBMITINFO',
  },
  {
    name: 'Initiate Discharge',
    id: 'ENHANCEMENT',
  },
  {
    name: 'Initiate Settlement',
    id: 'CASHLESSSUMBIT',
  },
];

export const TPA_DB_TAG_LIST_NAME = [
  {
    name: 'Drafts Pending',
    id: 'DRAFTCLAIM',
    sectionType: 4,
  },
  {
    name: 'Queries Pending',
    id: 'PENDINGQUERY',
    sectionType: 2,
  },
  {
    name: 'Awaiting Discharge',
    id: 'AWAITINGDISCHARGE',
    sectionType: 3,
  },
  {
    name: 'Approval Pending',
    id: 'APPROVALPENDING',
    sectionType: 1,
  },
];

export const TPA_DB_TAG_LIST_PRE_AUTH_VIEW = [
  {
    name: 'PA Draft Pending',
    id: 'PREAUTHDRAFTS',
    sectionType: 4,
  },
  {
    name: 'PA Query Pending',
    id: 'PREAUTHPENDINGQUERY',
    sectionType: 2,
  },
  {
    name: 'Awaiting Discharge',
    id: 'AWAITINGDISCHARGE',
    sectionType: 3,
  },
  {
    name: 'PA Approval Pending',
    id: 'APPROVALPENDING',
    sectionType: 1,
  },
];
export const TPA_DB_TAG_LIST_CLAIM_VIEW = [
  {
    name: 'Claim Draft Pending',
    id: 'CLAIMVIEWDRAFTS',
    sectionType: 4,
  },
  {
    name: 'Claim Query Pending',
    id: 'CLAIMPENDINGQUERY',
    sectionType: 2,
  },
  {
    name: 'Awaiting Settlement',
    id: 'AWAITINGSETTLEMENT',
    sectionType: 1,
  },
  {
    name: 'Settled /Claims',
    id: 'SETTLEDCLAIMS',
    sectionType: 1,
  },

];
export const INPATIENT_SUB_FILTERS = [
  { id: 'NewAdmission', label: 'New admission', key: 'newAddmission' },
  { id: 'Enhancement', label: 'Enhancement', key: 'enhancement' },
  { id: 'Discharge ', label: 'Discharge', key: 'discharge' },
];

export const TPA_TIME_FILTER_CONST = {
  ALL: 'All',
  TOMORROW: 'Tomorrow',
  TODAY: 'Today',
  LAST3HRS: 'Last3Hours',
};

export enum DRAFT_KEYS {
  newAdmission = 'newAdmission',
  ir = 'query',
  enhance = 'enhance',
  settlement = 'settlement',
  discharge = 'discharge',
  reconsider = 'reconsider',
  earlydischarge = 'earlydischarge',
  earlydischargequery= 'earlydischargequery',
  dischargeContest = 'dischargeContest',
}

export const draftSequence = [
  { key: DRAFT_KEYS.newAdmission, groupName: 'New Admission' },
  { key: DRAFT_KEYS.ir, groupName: 'Information Required' },
  { key: DRAFT_KEYS.enhance, groupName: 'Enhancement / Discharge' },
  { key: DRAFT_KEYS.settlement, groupName: 'Settlement' },
  { key: DRAFT_KEYS.discharge, groupName: 'Enhancement / Discharge' },
  { key: DRAFT_KEYS.reconsider, groupName: 'Enhancement / Discharge' },
  { key: DRAFT_KEYS.earlydischarge, groupName: 'Enhancement / Discharge' },
  { key: DRAFT_KEYS.earlydischargequery, groupName: 'Information Required' },
  { key: DRAFT_KEYS.dischargeContest, groupName: 'Enhancement / Discharge' },
];

export const DRAFTSTATUS_TO_INDEX_MAP: { [key: string]: number } = {
  'ENHANCEMENT': 2,
  'DISCHARGE': 4,
  'RECONSIDER': 5,
  'EASYDISCHARGEINITIATED': 6,
  'EASYDISCHARGEQUERYREPLIED': 7,
};

export const IR_STATUS_NAMES: Record<number, string> = {
  5: 'query',
  40: 'enhancementQuery',
  42: 'dischargeQuery',
  17: 'claimQuery',
  57: 'earlyDischargeQuery',
};

export const DIALYSIS_BILL_DETAIL_TEXT = 'Package amount is calculated on the basis of number of sessions claimed and the contracted package';

export const defaultDiagnosis = [{
  masterLookId: 14983,
  payerId: 1063871,
  lookupMasterType: 40,
  payerMasterId: 'O80',
  payerMasterValue: 'Delivery',
  masterTableName: null,
  maMasterId: 0,
  payerParentId: 0,
  payerParentValue: null,
  payerProductCode: null,
  lookupMasterValue: 'Diagnosis',
  label: 'Delivery / Pregnancy',
  name: 'Delivery / Pregnancy',
  value: '14983',
},
{
  masterLookId: 14980,
  payerId: 1063871,
  lookupMasterType: 40,
  payerMasterId: 'N17',
  payerMasterValue: 'Dialysis',
  masterTableName: null,
  maMasterId: 0,
  payerParentId: 0,
  payerParentValue: null,
  payerProductCode: null,
  lookupMasterValue: 'Diagnosis',
  label: 'Dialysis',
  name: 'Dialysis',
  value: '14980',
},
{
  masterLookId: 15008,
  payerId: 1063871,
  lookupMasterType: 40,
  payerMasterId: 'H25',
  payerMasterValue: 'Cataract',
  masterTableName: null,
  maMasterId: 0,
  payerParentId: 0,
  payerParentValue: null,
  payerProductCode: null,
  lookupMasterValue: 'Diagnosis',
  label: 'Cataract',
  name: 'Cataract',
  value: '15008',
},
{
  label: 'Other',
  name: 'Other',
  value: 'Other',
},
];

export const policyGroups: any = {
  ABHI: {
    'GHI': 'Affinity',
    '7': 'Affinity',
    '6': 'Affinity',
    '8': 'Group',
    '5': 'Group',
    '1': 'Retail',
    '2': 'Retail',
  },
};

export const CATARACT_EYE_TYPE_ICD_MAPPING: any = {
  'Left Eye': 'H25.012',
  'Right Eye': 'H25.011',
};

export const DEFAULT_PROD_DIAGNOSIS_ICDS = ['O80', 'H25', 'N17'];

export const defaultProdDiagnosis = [
  {
    label: 'Other',
    name: 'Other',
    value: 'Other',
  },
];

export const RECONCILIATION_FILE_TYPES = ['text/csv'];

export const CATARACT_APPROACH_OPTIONS = ['Conventional', 'MICS', 'SICS', 'Laser'];

export const NOT_ALLOWED_CHARACTERS = /[^\x00-\x7F]|[!*'();:@&=+$,/?%#[]/;
export const NOT_ALLOWED_CHARACTERS_RPA = /[^\x00-\x7F]|[!*'();:@&=+$,/?%#[-_.]/;
export const CHARS_TO_REPLACE = /\[\^\\x00-\\x7F\]\||\[|\]/g;

export const FORM_SUBMIT_EVENTS = {
  SUBMIT: 'SUBMIT',
};

export const DECLARATION_FORM_INSURER_IDS = ['1', '6', '5', '4'];

export const TIMELINE_DETAIL_TABLE_COLUMNS_TITLE = [
  {
    title: 'Status',
    dataIndex: 'title',
    key: 'title',
    fixed: 'left' as 'left',
    render: (status: any, data: any): any => {
      let statusClassName = '';
      CRM_INPATIENT_STATUS_COLOUR.map((colorObject: any): any => {
        if (colorObject.StatusId === data?.statusId) {
          statusClassName = colorObject.class;
        }
      });
      return (
        <span className={`fsize_sm bold status-text ${statusClassName}`}>{status && status}</span>
      );
    },
  },
  {
    title: 'Submitted By',
    dataIndex: 'submittedBy',
    key: 'submittedBy',
    fixed: 'left' as 'left',
    width: '100',
    render: (status: any, data: any): any => {
      let statusClassName = '';
      statusClassName = TIMLINE_MODAL_TABLE_SUBMITTED_COLOR[data.submittedBy];
      return (
        <span className={`fsize_sm bold status-text ${statusClassName}`}>{status && status}</span>
      );
    },
  },
  {
    title: 'Remark',
    dataIndex: 'remarks',
    key: 'remarks',
  },
  {
    title: 'Treatment',
    dataIndex: 'procedureDesc',
    key: 'procedureDesc',
  },
  {
    title: 'Proposed line of treatment',
    dataIndex: 'procedureType',
    key: 'procedureType',
  },
  {
    title: 'Claimed Amount',
    dataIndex: 'claimedAmount',
    key: 'claimedAmount',
    className: 'column-money',
    render: (amount: any): any => (
      <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
    ),
  },
  {
    title: 'Approved Amount',
    dataIndex: 'approvedAmount',
    key: 'approvedAmount',
    className: 'column-money ',
    render: (amount: any): any => (
      <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
    ),
  },
  {
    title: 'Created Date',
    dataIndex: 'createdDate',
    key: 'createdDate',
    render: (date: any): any => (
      <Tooltip placement="top" title={`${date && getDateWithTime(date)}`}>
      {date && getDateWithTextMonth(date)}
      </Tooltip>
    ),
  },
  {
    title: 'DOA',
    dataIndex: 'doa',
    key: 'doa',
    fixed: 'right' as 'right',
    render:   (date: any): any => (
    <Tooltip placement="top" title={`${date && getDateWithTime(date)}`}>
      {date && getDateWithTextMonth(date)}
    </Tooltip>
   ),
  },
  {
    title: 'DOD',
    dataIndex: 'dod',
    key: 'dod',
    fixed: 'right' as 'right',
    render: (date: any): any => (
      <Tooltip placement="top" title={`${date && getDateWithTime(date)}`}>
        {date && getDateWithTextMonth(date)}
      </Tooltip>
    ),
  },
];

export const ADMISSION_FORM_TYPES = {
  NORMAL: 'NORMAL',
  MULTIPAYER: 'MULTIPAYER',
  CORPORATE: 'CORPORATE',
};

export const SETTELLMANT_CHECKLIST_DATA_MPKAY = [
  {
    index: 1,
    particular: `Emp ID & Patient ID (Emp ID – Police ID card) (Patient ID – Ration card mandatory & other ID proof like
       [Aadhar Card etc.]`,
  },
  {
    index: 2,
    particular: `MPKAY Documents (Member Verification Form, Family Declaration Form, Annexure – B (Parisist form), Self Declaration form, Hospital Stay Certificate, Form C & D)`,
  },
  {
    index: 3,
    particular: `Original Hospital bill (break up of various heads like Room rent / OT charges / ICP notes / Treatment sheet / Nursing etc.,)`,
  },
  {
    index: 4,
    particular: `Original Discharge Summary & Death certificate (Gives the summary of diagnosis and treatment in hospital)`,
  },
  {
    index: 5,
    particular: `Original Pharmacy and Investigation bills with invoice and stickers (Along with prescriptions & Lab reports for all tests done along with images)`,
  },
  {
    index: 6,
    particular: `Stay NOC certificate (from hospital) if any`,
  },
  {
    index: 7,
    particular: `MLC Letter / Family Planning certificate, if any`,
  },
];

export const REDIRECT_URL_CONF = {
  GMAIL : window.location.origin + '/mailbox-configuration-response/gmail/',
};

export const getRandomInt = (min: number, max: number): number => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const PERFORMANCE_CARD_MONTHS_OPTIONS = [
  { value : 'THIS_MONTH', label : 'This Month'},
  { value : 'PREVIOUS_MONTH', label : 'Previous month'},
];

export const DISABLE_PERFORMANCE_CARD_DATE_BEFORE = new Date('09/11/2022');

export const requiredDocuments = [{'Bajaj': 'Pre-authorization Form, Consultation Papers, Govt-Id Prof, Investigation Reports, Indoor Case Papers and Health Card'},
{'CARE' : 'Pre-auth Form/ClaimForm, ID Proof, Adress Proof'},
{'SHAI': 'Discharge Summary, Final Bill with Breakup of it\'s components, All Investigation Reports - Lab Reports, Investigation Reports - Films - X Rays/USG/ECHO/MRI/CT Scan/HPE, Operation Theatre Notes, Indoor Case Papers, Medicine Bills and Dr Prescriptions, Others'}];

export const PARAMOUNT_SETTLEMENT_BRANCH_OPTIONS = ['Ahmedabad', 'Bangalore', 'Chennai', 'Hyderabad', 'Indore', 'Jaipur',
'Kochi', 'Kolkata', 'Mumbai', 'New Delhi', 'Pune', 'Surat', 'Vadodara'];

export const PARAMOUNT_SETTLEMENT_DOCUMENT_TYPE_OPTIONS = ['All documents are original', 'Documents contains zerox copies'];

export const VIDAL_SETTLEMENT_DOCUMENT_TYPE_OPTIONS = [BY_HAND, BY_COURIER];

export const ICICI_TYPE_OF_CLAIM_OPTIONS = ['Cashless', 'Addendum', 'OPD Cashless'];

export const ICICI_DOCUMENT_SUBMISSION_OPTIONS = ['Web', 'Dispatch'];

export const getClaimListTableMapping = (
  showFullNames: boolean,
  toggleFullNames: () => void,
  isConfigurator: boolean = false, // Flag to determine context
): any => {

  const claimsDisplayMappingColumns = {
    IP_NO: {
      title: 'Inpatient No.',
      dataIndex: 'inPatientNo',
      key: 'inPatientNo',
      column: '5%',
      render: (inPatientNo: any): any => (
        getDefaultStr(inPatientNo, true)
      ),
    },
    MAID: {
      title: 'Member Id',
      dataIndex: 'memberId',
      key: 'memberId',
      column: '5%',
      render: (memberId: any): any => (
        getDefaultStr(memberId, true)
      ),
    },
    policy_number: {
      title: 'Policy No',
      dataIndex: 'policyNo',
      key: 'policyNo',
      column: '5%',
      render: (policyNo: any): any => (
        getDefaultStr(policyNo, true)
      ),
    },
    CLAIM_NO: {
      title: 'Claim No',
      dataIndex: 'payerClaimNo',
      key: 'payerClaimNo',
      column: '5%',
      render: (claimNo: any): any => (
        getDefaultStr(claimNo, true)
      ),
    },
    MEMBER_NAME: {
      title: !isConfigurator ? (
        <>
          Patient Name
          <Tooltip title={showFullNames ? 'Hide All Names' : 'Show All Names'}>
            <span
              onClick={toggleFullNames}
              className="mask-eye-icon"
            >
              {showFullNames ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            </span>
          </Tooltip>
        </>
      ) : (
        'Patient Name'
      ),
      className: 'text-left',
      dataIndex: 'patientName',
      key: 'patientName',
      render: (patientName: string): { children: JSX.Element } => ({
        children: (
          <MaskedNameWithToggle
            patientName={patientName}
            showFullName={showFullNames}
          />
        ),
      }),
    },
    PAYER_NAME: {
      title: 'Payer',
      dataIndex: 'payerName',
      key: 'payerName',
      render: (payerName: any, row: any): any => (
        getTruncatedString(getDefaultStr(payerName, true))
      ),
    },
    INSURER_NAME: {
      title: 'Insurer Name',
      dataIndex: 'insurerName',
      key: 'insurerName',
      render: (insurerName: any, row: any): any => (
        getTruncatedString(getDefaultStr(insurerName, true))
      ),
    },
    CLAIMED_AMOUNT: {
      title: 'Claimed Amount',
      key: 'claimedAmount',
      dataIndex: 'claimedAmount',
      column: '5%',
      className: 'column-money text-left',
      render: (amount: any): any => (
        <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
      ),
    },
    APPROVED_AMOUNT: {
      title: 'Approved Amount',
      key: 'approvedAmount',
      dataIndex: 'approvedAmount',
      column: '5%',
      className: 'column-money text-left',
      render: (amount: any): any => (
        <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
      ),
    },
    STATUS: {
      title: 'Status',
      dataIndex: 'statusName',
      key: 'statusName',
      render: (status: any, data: any): any => {
        let statusClassName = '';
        CRM_INPATIENT_STATUS_COLOUR.map((colorObject: any): any => {
          if (colorObject.StatusId === data?.statusId) {
            statusClassName = colorObject.class;
          }
        });
        return (
          <span className={`fsize_sm bold status-text ${statusClassName}`}>{status && status}</span>
        );
      },
    },
    DOA: {
      title: 'DOA',
      dataIndex: 'doa',
      column: '5%',
      key: 'doa',
      render: (date: any): any => (
        date && getDateWithTextMonth(date)
      ),
    },
    LAST_MODIFIED_DATE: {
      title: 'Last Modified Date',
      dataIndex: 'modifiedOn',
      column: '5%',
      key: 'modifiedOn',
      className: 'column-money text-left',
      render: (date: any): any => (
        date && getDateWithTextMonth(date)
      ),
    },
    CLAIM_CREATION_DATE: {
      title: 'Claim Creation Date',
      dataIndex: 'createdOn',
      column: '5%',
      key: 'createdOn',
      className: 'column-money text-left',
      render: (date: any): any => (
        date && getDateWithTextMonth(date)
      ),
    },
    UHID: {
      title: (<div className="columnsTitle"><div><Tooltip title="UHID" placement="bottom">UHID</Tooltip></div>
        <span className="sort-icon-container">
          <CustomSort sortKey="uhid" />
        </span></div>),
      customTitle: 'UHID',
      className: 'text-left',
      dataIndex: 'uhid',
      key: 'uhid',
      render: (uhid: any): any => ({
        children: getDefaultStr(uhid, true),
      }
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="uhid" />,
      ...getColumnSearchDropdown({
        filterKey: 'uhid',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search UHID',
      }),
    },
  };

  return claimsDisplayMappingColumns;
};

export const getFileSizeLimitMessage = (maxFileSizeMB: any): any =>
  `File size exceeds ${maxFileSizeMB}MB. <br />Please download, compress, and upload again to submit.`;

export const NHCX_PRODUCT_CODE_WHITELISTING_LIST = ['2856', '2805', '2803', '2849', '2850', '5000', '5001', '5006', '5012', '5023', '5028', '2806', '2814', '2815', '3810', '2804'];
export const RECONSIDERATION_REQUEST_STATUS = 53;

export const BLUE_BACKGROUND = '#3C3ADA';

export const WHITE_BACKGROUND = '#fff';

export const fileTextMessage = <p>(Pre-auth Form, Consultation papers, Govt-ID Proof,
Investigation reports, Indoor case papers and Health card)</p>;

export const MAX_FILE_LIMIT_COUNT = 15;

export const PROGRESS_COLOR_GRAY = '#E15554';

export const PROGRESS_COLOR_GREEN = '#2AE1AA';

export const ITEMS_PER_PAGE = 6;

export const DOD_VALIDATION_MESSAGE = 'DOD must be greater than DOA by at least 30 minutes.';

export const QUERY_DRAFT_FLOW = ['query', 'enhancementQuery', 'dischargeQuery', 'claimQuery', 'earlyDischargeQuery'];

export const DAY_CARE_TYPE_DRAFT_KEYS = ['newAdmission', 'enhance', 'discharge', 'earlydischarge'];

export const TPA_RANGE_VALIDATION_MESSAGE = 'Please select a valid time range.' ;

export const DISCHARGE_TIME_MUST_BE_GREATER_THAN_30_MINS = 'Discharge time must be greater than 30mins.';

export const DRAFTS_ACCESS_MESSAGE = 'The User doesn\'t have access to drafts because they do not have the necessary permissions to submit cases';

export const PATIENT_NAME_VALIDATION_MSG = 'Patient name is required!';

export const PATIENT_NAME_MAX_CHAR_LIMIT = 'Patient Name cannot be longer than 50 characters';

export const PATIENT_NAME_MIN_CHAR_LIMIT = 'Patient Name cannot be less than 4 characters';

export const MB2Bytes = 1024 * 1024;

export const MIN_DOCUMENT_MESSAGE = 'Minimum document required is';

export const MAX_DOCUMENT_MESSAGE = 'maximum documents uploaded can not exceed more than';

export const PAN_MANDATORY = 'has made the Pan Card number mandatory for all the claims, irrespective of the claimed amount, based on the new IRDA guidelines.';

export const EMPLOYEE_ID_REGEX = /[^a-zA-Z\d\-]*/gm;
export const FORM_POLICY_NO_REGEX = /[^a-zA-Z\d\\\-/_]*/gm;
export const CORPRATE_NAME_REGEX = /[^A-Za-z\b\-//()-*_,:;.&+| ]*/gm;
export const DOCTOR_NAME_REGEX = /^dr\.?\s*/i;

export const SELECT_FOR_NEW_BORN = 'Select this for Newborn Baby Preauthorization Request';

export const FILE_CHECKBOX_SELECTION = `Please check all the boxes below to <b>confirm</b> that all the <b>required documents</b> are provided.`;

export const FILE_UPLOAD_QUERY = 'Please ensure that the following documents are uploaded to reduce chances of queries.';

export const SETTLEMENT_KEY = 'settlement_';

export const OLD_DOCUMENT_UPLOAD_FLOW = 'oldDocumentFlow';

export const HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW = 'hisDocumentFlow';

export const NON_HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW = 'nonHisDocumentFlow';

export const MDI_MEMBER_SEARCH_CRITERIA = ['Patient Name, Policy No., MIN No. / Employee ID', 'Member ID/MDID, Policy No., Patient Name', 'MIN No. / Employee ID, Member ID/MDID, Patient Name' ];

export const MDI_MEMBER_REDESIGN_SEARCH_CRITERIA = ['Policy No., MIN No. / Employee ID, Patient Name', 'Policy No., Member ID/MDID, Patient Name', 'MIN No. / Employee ID, Member ID/MDID, Patient Name' ];
export const PROGRESS_LEVEL = '#2ABF86';

export const OTHER_INJURY_REASON_OPTIONS = ['Accident', 'Sports/Activity', 'Scuicide or Scuicidal Attempt /Intentional Self Injury'];

export const baseUrl = GLOBAL_URL.CRM_BASE_URL;

export const preAuthViewTpaConst = {
  DRAFTPENDING: {
    title: 'DRAFT PENDING',
  },
  QUERYREPLYPENDING: {
    title: 'QUERY REPLY PENDING',
  },
  AWAITINGDISCHARGE: {
    title: 'DISCHARGES',
  },
  APPROVED: {
    title: 'APPROVED',
  },
  APPROVALPENDING: {
    title: 'APPROVAL PENDING',
  },
  DENIEDCANCELLED: {
    title: 'DENIED / CANCELLED',
  },
  NEEDHUMANINTERVENTIONNHI: {
    title: 'NEED HUMAN INTERVENTION (NHI)',
  },
};
export const claimViewTpaConst = {
  DRAFT_PENDING: {
    title: 'DRAFT PENDING',
  },
  DUE_FOR_CLAIM_SUBMISSION: {
    title: 'DUE FOR CLAIM SUBMISSION',
  },
  CLAIM_QUERY_PENDING: {
    title: 'CLAIM QUERY',
  },
  CLAIM_IN_PROGRESS: {
    title: 'CLAIM IN PROGRESS',
  },
  SETTLED_CLAIMS: {
    title: 'SETTLED',
  },
  DENIED_CANCELLED: {
    title: 'DENIED',
  },
  NEED_HUMAN_INTERVENTION_NHI: {
    title: 'NEED HUMAN INTERVENTION (NHI)',
  },
  PA_UTILISATION_PENDING: {
    title: 'PA UTILISATION PENDING',
  },
};

const generateFormState = (fields: string[]): Record<string, {
  isShowSuggestedValue: boolean,
  hasValue: boolean,
  isFocused: boolean,
 }> =>
  fields.reduce((acc: any, field: any): any => {
    acc[field] = { isShowSuggestedValue: false, hasValue: false, isFocused: false };
    return acc;
  }, {});

export const formInputStates = {
  emailForm: generateFormState([
    'fullName', 'mobile', 'memberId', 'memberAge', 'policyNumber', 'employeeId',
    'payerCopy', 'insurerName', 'corporateName', 'inPatientNumber', 'emailId',
    'stayLength', 'diagnosis', 'payerRoomType', 'doctorName', 'doctorRegNo', 'claimedAmount',
    'procedure', 'admissionType', 'dayCareType',
  ]),
  memberDetailsForm: generateFormState([
    'fullName', 'mobile', 'memberId', 'memberAge', 'policyNumber', 'employeeId',
    'payerCopy', 'insurerName', 'corporateName', 'inPatientNumber', 'emailId',
    'healthId', 'corporateNameDropdown', 'memberGenderSex', 'dateOfBirth', 'policyType',
    'memberGenderSelect', 'insurerNameText', 'payer', 'hospitalNumber', 'kycPan',
    'insuranceCardNumber', 'aadharNo',
  ]),
  treatmentDetailsform: generateFormState([
    'stayLength', 'diagnosis', 'diagnosisDropDown', 'doctorName', 'automatedProcedure',
    'hospitalRoomType', 'payerRoomType', 'roomTypeText', 'doctorRegNo', 'procedure', 'procedureDropDown',
    'routeOfAdministration', 'stateMedicalCouncil', 'stateMedicalCouncilText', 'doctorQualification',
    'doctorQualificationDropDown', 'doctorSpecialization', 'dayCareType', 'systemOfMedicine', 'surgeryType', 'dateOfSurgery',
    'conditionOnDischarge', 'presentComplaints', 'hospitalizationReason', 'subGroup', 'cataractOperatedFor',
    'sinceWhenDuration', 'sinceWhenPeriod', 'doctorMobileNo',
  ]),
  accidentCardForm: generateFormState([
    'dateOfInjury', 'firNumber', 'accidentDueTo', 'reasonForInjury',
  ]),
  pastHistoryForm: generateFormState([
    'ailment', 'otherAilment', 'pastHistoryOfPresentAilment',
  ]),
  RPARedesignBenefForm: generateFormState([
    'memberId', 'corporateName', 'policyNumber', 'employeeId', 'patientName', 'policyType',
    'mobile', 'policyName', 'status', 'certificateNumber', 'coiNumber', 'dateOfAdmission',
    'corporateNameDropdown', 'insurerName',
  ]),
  IPPRedesignBenefForm: generateFormState([
    'memberId', 'corporateName', 'policyNumber', 'employeeId', 'patientName', 'policyType',
  ]),
  PolicyRedesignForm : generateFormState([
    'patientName', 'mobileNo', 'healthId',
  ]),
  buddhimedFileUploadForm: generateFormState(['panNumber', 'fileUploadRemark']),
  maternityCardForm: generateFormState([
    'typeOfMaternity', 'noOfBiologicalChildren', 'noOfAdoptedChildren', 'noOfDeliveries', 'lmp', 'deliveryDate',
  ]),
  automatedOtherTreatmentDetailForm: generateFormState([
    'admissionType', 'rpaAdmissionType', 'routeOfAdministrationText', 'eye', 'treatmentApproach', 'lossType', 'dateOfDiagnosis',
  ]),
  otherMemberDetailsCard: generateFormState([
    'relation', 'relationTextInput', 'aadharNo', 'memberEmergencyContactPerson',
  ]),
};

export const HIS_CARD_LABELS: any = {
  0: ['Doctor Name', 'Date of Visit', 'Department', 'Line of Treatment', 'Date of Admission', 'Diagnosis'], // default
  3: ['Doctor Name', 'Date of Visit', 'Visit Type', 'Department'], // T3
};

export const EMPLOYEE_ID_VALIDATION_MESSAGE_MDI = 'Employee ID/MIN No. is required!';

export const EMPLOYEE_ID_VALIDATION_MESSAGE = 'Employee ID is required!';

export const EMPLOYEE_ID_PLACEHOLDER_MDI = 'Enter Employee ID/MIN No.';

export const EMPLOYEE_ID_PLACEHOLDER = 'Enter Employee ID';

export const TREATMENT_TYPE = 'treatmentType';

export const SHAI_DISABLED_BENEF_MESSAGE = 'We are currently unable to process this request for the policyholder. Our team is actively collaborating with Star Health and Allied Insurance (SHAI) to resolve this issue and accommodate these requests as soon as possible please submit this case over email.';

export const GENERIC_DISABLED_BENEF_MESSAGE = 'We are currently unable to process this request for the policyholder.';

export const NON_NUMERIC_REGEX = /[^0-9.]/g;
export const DEFAULT_VISIT_CODE = '0';

// Type definitions
export interface HISPayload {
  loggedInUserId: string;
  hisMasterID: string;
  hisProviderID: string;
  visitCode?: string;
  hisPatientReferenceNumber?: string;
  uhid?: string;
  ipNumber?: string;
  visitType?: string;
  mobileNo?: string;
}

export interface HISParams {
  visitCode: string;
  visitType: string;
  uhid: string;
  ipNumber: string;
  hisPatientReferenceNumber: string;
}

// Define common configuration patterns
const HIS_OPTION_FIELDS = {
  UHID_ONLY: {
    optionFields: ['uhid'] as const,
    requireAll: false,
    getPayload: ({ uhid }: HISParams): Partial<HISPayload> => ({ uhid }),
  },
  IP_ONLY: {
    optionFields: ['ipNumber'] as const,
    requireAll: false,
    getPayload: ({ ipNumber }: HISParams): Partial<HISPayload> => ({ ipNumber }),
  },
  UHID_IP: {
    optionFields: ['ipNumber', 'uhid'] as const,
    requireAll: false,
    getPayload: ({ uhid, ipNumber }: HISParams): Partial<HISPayload> => ({
      uhid,
      ipNumber,
    }),
  },
  T3_SPECIFIC: {
    optionFields: ['uhid', 'visitCode', 'visitType'] as const,
    requireAll: true,
    getPayload: ({ uhid, visitCode, visitType }: HISParams): Partial<HISPayload> => ({
      visitType,
      uhid,
      visitCode,
    }),
  },
} as const;

// Create type for HIS configuration based on pattern keys
type HISConfigType = typeof HIS_OPTION_FIELDS[keyof typeof HIS_OPTION_FIELDS];

export const HIS_CONFIG: Record<string, HISConfigType> = {
  // T3
  '3': HIS_OPTION_FIELDS.T3_SPECIFIC,
  // Jupiter
  '2': HIS_OPTION_FIELDS.UHID_IP,
  // MAX
  '4': HIS_OPTION_FIELDS.UHID_ONLY,
  // Akhil
  '5': HIS_OPTION_FIELDS.UHID_IP,
  // MHC
  '6': HIS_OPTION_FIELDS.UHID_IP,
  // Dr. Agarwal
  '7': HIS_OPTION_FIELDS.IP_ONLY,
  // Demo
  '77': HIS_OPTION_FIELDS.UHID_IP,
} as const;

export const GENDER_OPTIONS = ['Male', 'Female', 'Other'];
export const OTHER_GENDER_OPTIONS = ['Male', 'Female', 'Transgender'];

export const SELECT_RIGHT_POLICY = 'Are you sure you have selected the right Policy? Please click on \'Proceed\' to continue or click \'Cancel\' to choose the right Policy.';
export const SKIPPED_BENEF_SEARCH = 'Step skipped; moved to the next step as no beneficiaries match the search';

export const VALUE_NOT_UPDATED = 'Not Updated';

export const MISSING_VALUE_ERROR = {
  patientName : 'Please Enter Patient Name',
  memberId : 'Please enter Member Id',
};

export const EXTENTION_KEYS = {
  BENEF_FAILURE: 'memberSearchFailed',
  VISIT_CODE: 'visitCode',
  VISIT_TYPE: 'visitType',
  UHID: 'uhid',
  PATIENT_REFERENCE_NO: 'patientHISReferenceNumber',
  TREATMENT_TYPE: 'treatmentType',
  IS_MERGED_CLAIM: 'isClaimsMergedFlow',
  IS_INBOUND_ERROR: 'isInboundError',
  DAY_CARE_TYPE: 'dayCareType',
  NEW_PACKAGE_NAME: 'newPackageName',
  CATARACT_OPERATED_FOR: 'cataractOperatedFor',
  REASON_FOR_ENHNACEMENT: 'reasonForEnhancement',
  REASON_FOR_RECONSDIERATION: 'reasonForReconsideration',
};

export const DATE_DROPDOWN_FILTERS = [
  { value: 'All Dates', label: 'Filter All Dates' },
  { value: 'Last Modified', label: 'Filter Last Modified' },
  { value: 'Claim Creation', label: 'Filter Claim Creation' },
  { value: 'DOA', label: 'Filter DOA'},
  { value: 'DOD', label: 'Filter DOD'},
];

export const DATE_DROPDOWN_MODELIING = {
  'All Dates': ['DOA', 'DOD', 'ModifiedOn', 'CreatedOn'], // Store as an array
  'Last Modified': 'ModifiedOn',
  'Claim Creation': 'CreatedOn',
  'DOA': 'DOA',
  'DOD': 'DOD',
};

export const BENEF_RETRY_MESSAGE = {
  RETRY_MEMBER_SEARCH_WITH_POLICY: (
    <p><b>Retry Member Search</b> with <b>Policy Number</b> for successful result.</p>),
  MDI_RETRY_MESSAGE: (<p className="fsize_xl"><b>Reminder</b>: "If you have a <b>MIN Number</b>,
    please select <b>{BENEFICIARY_SEARCH_OPTION_MDI[1]}</b> instead of <b>{BENEFICIARY_SEARCH_OPTION_MDI[0]}</b> to proceed correctly"</p>),
  GENERIC_RETRY_MESSAGE: (<p><b>Retry Member Search with correct patient details for Faster
    Approval.</b>
  </p>),
  MDI_MEMBER_ID_SELECTION_MESSAGE: (<p className="memberid-selection-info">
    If you have <b>Insurer Member ID </b>then proceed with <b>Employee Id / Policy No.</b> search
</p>),
  MDI_CORPORATE_SEARCH_INFO: (<p>Policy number entered is a corporate policy, please select <b>'Corporate'</b>
  as the policy type and search again</p>),
};

export const MDI_MEMEBERID_REGEX = /^MD(?!I5-)/;

export const MDI_MEMBERID_PREFIX = 'MDI5-';

export const MDI_MEMBERID_VALID_MESSAGE = 'Please input the member id in correct format';

export const BENEF_CONSTANTS = {
  CUSTOMER_ID: 'Customer ID (Group / Retail)',
  MEMBER_ID: 'Member ID',
  CUSTOMER_ID_PLACEHOLDER: 'Enter Customer ID (Group / Retail)',
  MEMBER_ID_PLACEHOLDER: 'Enter Member ID',
  POLICY_NO_RETAIL: 'Policy No. (Retail Only)',
  POLICY_NO: 'Policy No.',
  POLICY_NO_RETAIL_PLACEHOLDER: 'Enter Policy No. (Retail Only)',
  POLICY_NO_PLACEHOLDER: 'Enter Policy No.',
  CUSTOMER_ID_VALIDATION_MESSAGE: 'Customer ID (Group / Retail) is required!',
  POLICY_NUMBER_VALIDATION_MESSAGE: 'Policy No. (Retail Only) is required!',
  POLICY_NO_VALIDATION_MESSAGE: 'Policy No. is required!',
  MDI_PLACEHOLDER: 'Enter MDID',
  PATIENT_NAME_PLACEHOLDER: 'Enter Patient Name',
  PATIENT_NAME_SMALL_PLACEHOLDER: '(Full name as per Member Card / Policy)',
  PATIENT_NAME_MAX_LIMIT: 'Patient Name cannot be longer than 50 characters',
  OPTIONAL_PLACEHOLDER: '(Optional)',
  MOBILE_PLACEHOLDER: 'Enter Mobile No.',
  EMPLOYEE_ID_VALIDATION_MESSAGE_MDI: 'MIN No. / Employee ID is required!',
  EMPLOYEE_ID_VALIDATION_MESSAGE: 'Employee ID is required!',
  EMPLOYEE_ID_PLACEHOLDER_MDI: 'MIN No. / Enter Employee ID',
  EMPLOYEE_ID_PLACEHOLDER: 'Enter Employee ID',
  POLICY_NUMBER_PLACEHOLDER: 'Enter Policy No.',
  MDID: 'MDID',
  MDI_MEMBERID_PLACEHOLDER: 'Enter Member ID/MDID',
  POLICY_TYPE_LABEL: 'Select Policy Type',
};

export const INPATIENT_TEXT_MAPPING = {
  'patientName': 'Patient Name',
  'payerClaimNo': 'Claim No.',
  'transactionId': 'UTR No.',
};

export const NON_CONFIGURED_PAYERS_LIST_MESSAGE =  'There are no payers enabled for this Provider';

export const NON_CONFIGURED_PAYERS_DRAFT_ERROR = 'The Draft cannot be opened as this Payer is not currently active for this Provider';

export const NON_CONFIGURED_PAYERS_BLOCK_POST_PRE_AUTH = 'This action cannot be performed as this Payer is not currently active for the Provider';

export const DATEPICKER_ERROR_MESSAGE = 'Both admission and discharge dates are required!';

export enum INPATIENT_PATH {
  NEW_ADMISSION = 'newAdmission',
  EDIT =  'edit',
  DISCHARGE = 'discharge',
  RECONSIDER = 'reconsider',
  DETAIL = 'detail',
}
export const POLICY_TYPE_OPTIONS = {
  CUSTOMER_TYPES: ['Individual', 'Group'],
  SECTOR_TYPES: ['Retail', 'Corporate'],
};

export const BENEF_NOT_FOUND_MESSAGE = 'Details not found, please continue to submit the claim on IHX';

export const BENEF_PRIMARY_KEY_MAP:  Record<string, string> = {
  'MDID': 'MemberId',
  'MIN No. / Employee ID': 'EmployeeId',
  'Policy No.': 'PolicyNumber',
};

export const REASON_FOR_HOSPITALIZATION_OPTIONS = ['Ailments', 'Injury', 'Maternity'];

export const REASON_FOR_HOSPITALIZATION_OPTIONS_GO_DIGIT = ['Illness', 'Accident', 'Maternity'];

export const ATLEAST_ONE_BILL_ITEM_MESSAGE = 'Please add at least one bill item to proceed further with the submission';

// mapping between payload keys and their corresponding iHave values
export const PAYLOAD_TO_IHAVE: Record<string, string[]> = {
  'policyNo': ['Policy No.', 'Policy No. (Retail Only)'],
  'memberId': ['Member ID', 'MDID', 'Customer ID (Group / Retail)', 'Client ID'],
  'employeeId': ['Employee ID', 'MIN No. / Employee ID'],
  'coiNo': ['COI No.'],
  'policyName': ['Policy Name'],
  'corporateName': ['Corporate Name'],
  'certificateNo': ['Certificate No.'],
  'sewarthNo': ['Sewarth No.'],
  'urnNo': ['URN No.'],
  'kgid': ['KGID'],
};

export const BENEF_WARNING_MESSAGE = 'Incorrect beneficiary selection may result in claim cancellations';
export const MEMBER_SELECTION_CONFIRMATION = 'Are you sure you have selected the right member? Please click on \'Proceed\' to continue or click \'Back\' to choose the right member.';

export const PREFIXES = {
  DOCTOR: 'Dr. ',
  MOBILE: '+91',
};

export const INCLUDE_OLD_DOCS_LABEL = 'Do you want to select New Admission and Discharge Documents for Settlement?';

export const HYPHEN_STRING = '-';

export const PAYERMASTER_TYPE = {
  DIAGNOSIS: 'Diagnosis',
  PROCEDURE: 'Procedure',
};

export const AUTOMATION_CANCELLED_INFO = 'Automation Cancelled';
export const NOTIFICATION_TYPE = {
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
};

export const HIS_ADDITIONAL_ATTRIBUTES_MAP_TYPE = {
  preAuthType: 'string',
  insuranceCardNumber: 'string',
  relationship: 'string',
  aadharNumber: 'string',
  reasonForHospitalization: 'string',
  systemOfMedicine: 'string',
  sinceWhen: 'string',
  sinceWhenUnit: 'string',
  eye: 'string',
  approach: 'string',
  surgeryType: 'string',
  presentComplaints: 'string',
  documentsSubmitted: 'string',
  podNo: 'string',
  courierAgencyOrPerson: 'string',
  handedOverTo: 'string',
  injuryCausedBy: 'string',
  accidentDueTo: 'string',
  isMLC: 'boolean',
  subGroup: 'string',
  noOfBiologicalChildren: 'string',
  noOfAdoptedChildren: 'string',
  noOfDeliveries: 'string',
  lmp: 'string',
  typeOfMaternity: 'string',
  doctorQualification: 'string',
  routeOfAdministration: 'string',
  isCovidCase: 'boolean',
  admissionType: 'string',
  stateMedicalCouncil: 'string',
  speciality: 'string',
};

export const DYNAMIC_FIELD_MAPPINGS = {
  hospitalizationReason: ['Ailments', 'Injury', 'Maternity'],
  hospitalizationReasonGoDigit: ['Illness', 'Accident', 'Maternity'],
  systemOfMedicine: ['Allopathy', 'Ayush'],
  sinceWhenPeriod: ['Days', 'Weeks', 'Months', 'Years'],
  cataractOperatedFor: ['Left Eye', 'Right Eye', 'Both eyes'],
  eye: ['Left Eye', 'Right Eye'],
  surgeryType: ['Major', 'Minor', 'SupraMajor', 'Intermediate'],
  conditionOnDischarge: ['Alive', 'Expired'],
  documentType: ['By Hand', 'By Courier'],
  accidentDueTo: ['Others', 'Road Traffic Accident', 'Self Accident'],
  subGroup: ['Ayurveda', 'Homeopathy', 'Siddha', 'Unani'],
  admissionType: ['Planned', 'Emergency'],
  admissionTypeKSRTC: ['IPD', 'OPD'],
  doctorQualification: ['MBBS', 'MD', 'MS', 'Others'],
  lossType: ['Illness', 'Accident'],
};

export const REASON_FOR_ENHANCEMENT_OPTIONS = ['Stay Extended', 'Additional Procedure planned', 'Additional complications'];

export const REASON_FOR_RECONSDIERATION_OPTIONS = ['Claim documents Re-Submission for payment',
  'Final Discharge Rejected - Re consideration',
  'Short Payment/ Partial Settlement', 'Wrong Deduction (Tariff/ Discount/ Bill Amount)'];

export const COMMON_PLT = ['Surgical Management', 'Medical Management'];

export const CANCELLATION_WITHOUT_DOCS_PAYERS = ['HERITAGE', 'GODIGIT'];

export const MDI_RETAIL_POLICY_ERROR_MESSAGE = 'Policy number entered is a corporate policy';

export const ICICI_PROCEDURES = ['Yoga and Naturopathy', 'Allopathy', 'Ayurveda', 'Homeopathy', 'Unani'];

export const ICICI_MATERNITY_TYPE_OPTIONS = ['Normal', 'C Section', 'Medical Management', 'Abortion'];

export const ICICI_ARTEMIS_INJURY_REASON_OPTIONS = ['Injury', 'Road Traffic Accident', 'Self Fall',	'Sports',	'Fall at Home',	'Assault', 'Self Inflicted', 'Substance/Alcohol Abuse'];

export const ORION_PRODUCT_CODE_ARTEMIS = 'ARTEMIS';

export const ORION_PRODUCT_CODE_FT = 'FT';

export const SURGICAL = 'Surgical Management';

export const DIAGNOSIS_LOOK_UP_BY_VALUE_PAYERS = ['HDFC', 'VOLO', 'TATA AIG'];
